/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import * as accountServices from "../services/accountService";
import * as eventServices from "../services/eventService";
import * as utilServices from "../services/utilService";
import * as dateUtil from "../util/date.util";
import * as authUtil from "../util/auth.util";
import * as realGamesService from "../services/realGamesService";
import Toast from "./sub_components/toast";
import UnsetteledBetsPopup from "./sub_components/unsetteledbetspopup";
import Currency from "./sub_components/currency";
import Depositpopup from "./sub_components/depositpopup";
// import socketIOClient from "socket.io-client";
// import { SOCKET_ROOT as ENDPOINT } from '../configs/api'
import {
    staticContentsImagePath as BASE_IMAGE_PATH,
    OPERATOR_ID,
} from "../configs/const";
import Footer from "./footer";
import * as stringParser from "../util/string.util";
import * as constants from "../configs/const";
import {
    casinoList,
    showBinary,
    showChangePasswordBtn,
    showLogoutBtn,
    showSportsBookLink,
    showEsportLink,
    showKabaddi,
    showElection,
    showClubGames,
    LBLTYPE,
    ShowB2BSignUpButton,
    ShowSportsBattle,
    ElectionDisplayLabel,
} from "../configs/casinoShowList";
import moment from "moment";
import Depositpopuphebebook from './sub_components/depositpopuphebebook';
import { APK_FILE_NAME, SOCIALMEDIALINKS } from '../configs/apkFileName';
import LiveClock from './sub_components/liveClock';
import Joinnowpopup from './sub_components/joinnowpopup';
import Loginpopup from './sub_components/loginpopup';
import { isJsonString } from "../util/jsoncnvt.util.js";
import { CaptchaAutoRefresh, LoginAndRegisterHaveURL } from "../configs/authSignupConfig.js";
import Marquee from "react-fast-marquee";
import { getNotification } from "../services/notificationservice";
// import * as Sentry from "@sentry/react";
const hostname = window && window.location && window.location.hostname;
let socket = null;
let oid = OPERATOR_ID.toLowerCase();
let accCall = null;
let evtData = null;
let dataIntervalCall = null;
let mqTime = null;
let loadEvtDataSetTimeOut = null;
let casinoPages = [
    "/indianpoker",
    "/indianpoker2",
    "/casino",
    "/virtualsports",
    "/casino2",
    "/sportbook",
    "/esport",
];
let eventPages = [
    "/home",
    "/inplay",
    "/multimarket",
    "/game/4",
    "/game/1",
    "/game/2",
    "/game/400",
    "/game/500",
];
const pathMarketToLoadFirst = ["/", "/auth", "/home", "/inplay"];
export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            accountData: {},
            rgAccountData: {},
            accessControl: {},
            showToast: false,
            toastMsg: "",
            toastType: "",
            showPopup: false,
            marquee: "",
            evtData: [],
            cktInplay: 0,
            socInplay: 0,
            tenInplay: 0,
            kbdInplay: 0,
            electInplay: 0,
            horsInplay: 0,
            houndInplay: 0,
            binaryInplay: 0,
            notificationCount: 0,
            scoreDetail: {},
            isMaintanance: false,
            isDev: false,
            showevolution: true,
            clientWidth: document.documentElement.clientWidth,
            isOfficeChannel: false,
            showJoinNowPopup: false,
            showLoginPopup: false,
            hasUmShow: true,
            eventdataloadtimer: 10000, //60000//10000
            pwdch: false,
            whatsAppLinkclickCounter: 0
        };
    }


    async componentWillMount() {
        // const tkndata = {
        //         "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJyaWNreTEiLCJyb2xlIjoiQ2xpZW50IiwiaXNzIjoiUkRSIiwiZXhwIjoxNjc4Mzg1ODE5MTc0LCJwd2RjaCI6ZmFsc2UsImlwIjoiMjIzLjIyOS4xNDkuMjYifQ.xF5VDNqFlfITYIvUFNiLp89D7TzNCeBOOAh93PSRsAM"
        //     }
        //     localStorage.setItem("userAuthDetail", JSON.stringify(tkndata));
        let self = this;
        if (constants.isDev
        ) {
            this.setState({ isDev: true });
        }

        const accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        if (!!profData && profData.role === 'DemoClient') {
            let demoExpo = sessionStorage.getItem('demoExpo')
            let demopl = sessionStorage.getItem('demoPnL')
            if (!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0) {
                demoExpo = JSON.parse(demoExpo);
                let totalexpo = (Object.values(demoExpo).reduce((a, v) => a = a + v, 0))

                // accData["balance"] = profData.balance + totalexpo;
                accData["exposure"] = totalexpo;
                accData["pnl"] = !!demopl ? demopl : 0;
            }
        }
        if (!!accData && accData.username) {
            this.setState({ accountData: accData, eventdataloadtimer: 10000 });
        } else {
            this.setState({ accountData: accData, eventdataloadtimer: 60000 });
        }
        let accesControl = {
            sports: true,
            binary: true,
            casino: true
        }
        localStorage.setItem("accessControl", JSON.stringify(accesControl));
        if (pathMarketToLoadFirst.includes(window.location.pathname)) {
            // const hmdt = JSON.parse(localStorage.getItem("homeData"));
            let hmdt = []
            if (window.location.pathname === '/inplay') {
                hmdt = await eventServices.getInPlayCurrentData();
            } else {
                hmdt = await eventServices.getHomeCurrentData();//JSON.parse(localStorage.getItem("homeData"));
            }
            if (Array.isArray(hmdt) && hmdt.length > 0) {
                hmdt = this.parseBook(hmdt);
            } else {
                hmdt = [];
            }
            if (!!hmdt) {
                this.loadEvtData(hmdt);
                // loadEvtDataSetTimeOut = setTimeout(() => {
                //     clearTimeout(loadEvtDataSetTimeOut);
                //     this.loadEvtData();
                // }, pathMarketToLoadFirst.includes(window.location.pathname) ? 500 : this.state.eventdataloadtimer);
            } else {
                // this.loadEvtData();
            }
        } else {
            let typeID
            let splitedpath = window.location.pathname.split('/');
            splitedpath.splice(0, 1);
            if (!!splitedpath && splitedpath.length > 0 && splitedpath[0] === 'game') {
                typeID = splitedpath[1];
                if (!!typeID) {
                    this.loadEvtData();
                }
            }
        }
        document.addEventListener("visibilitychange", function () {
            if (document.hidden) {
                localStorage.setItem("hideTime", new Date().getTime() / 1000);
            } else {
                if (!(!!accData && Object.keys(accData).length > 0) && CaptchaAutoRefresh && self.state.showLoginPopup) { // && ['/', '/auth']window.location.pathname ){
                    window.location.reload();
                } else {
                    let then = localStorage.getItem("hideTime");
                    if (!!then) {
                        let now = new Date().getTime() / 1000;
                        if (parseInt(now - then) > 3600 * 4) {
                            authUtil.logout();
                        } else {
                            if (pathMarketToLoadFirst.includes(window.location.pathname)) {
                                self.loadEvtData()
                            }
                        }
                        localStorage.removeItem("hideTime");
                    }
                }
            }
        });
    }

    async componentDidMount() {

        let userData = localStorage.getItem("tokenData");
        let xoroData = localStorage.getItem("xoroData");
        this.setState({ xoroData: JSON.parse(xoroData) });
        userData = JSON.parse(userData);
        socket = this.props.socket;

        if (
            this.state.isMaintanance &&
            window.location.pathname !== "/maintanance" &&
            window.location.pathname !== "/games/3droulette" &&
            window.location.pathname !== "/accountstatement" &&
            window.location.pathname !== "/profitloss" &&
            window.location.pathname !== "/bethistroy" &&
            window.location.pathname !== "/unsettledbet" &&
            window.location.pathname !== "/rules" &&
            window.location.pathname !== "/auth"
        ) {
            window.location.href = "/maintanance";
        }
        if (!!this.props.updateMaintanence) {
            this.props.updateMaintanence(this.state.isMaintanance);
        }

        if (this.props.updateSocket) {
            this.props.updateSocket(socket);
        }

        clearInterval(dataIntervalCall);
        clearTimeout(mqTime);
        let marqueeData = localStorage.getItem("marquee");
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
            if (!!marqueeData) {
                let self = this;
                this.setState({ marquee: marqueeData }, () => {
                    mqTime = setTimeout(async () => {
                        let marquee = await utilServices.getMarquee();
                        // let marquee = { "message": "" }
                        if (!!marquee && !!marquee.message) {
                            self.setState({ marquee: marquee.message });
                            localStorage.setItem("marquee", marquee.message);
                        }
                    }, 10000);
                    dataIntervalCall = setInterval(async () => {
                        let marquee = await utilServices.getMarquee();
                        // let marquee = { "message": "" }
                        if (!!marquee && !!marquee.message) {
                            self.setState({ marquee: marquee.message });
                            localStorage.setItem("marquee", marquee.message);
                        }
                    }, 30000);
                });
            } else {
                let marquee = await utilServices.getMarquee();
                this.setState({ marquee: marquee.message });
                localStorage.setItem("marquee", marquee.message);
            }
        } else {
            setTimeout(() => {
                if (window.location.pathname === '/login') {
                    this.showPopup("Login")
                }
                if (window.location.pathname === '/register') {
                    this.showPopup("JoinNow")
                }

            }, 500);
        }
        let accessControl = localStorage.getItem("accessControl");
        accessControl = !!accessControl ? JSON.parse(accessControl) : {};
        let tagList = ["svg", "path", "g"];

        if (this.props.isCasinoFull) {
            document.addEventListener("click", (e) => {
                if (
                    !e.target.className ||
                    tagList.includes(e.target.tagName) ||
                    e.target.className.split(" ").indexOf("cmenu") === -1
                ) {
                    if (!this.state.isMaintanance) {
                        if (
                            (!!document.getElementById("multiBalancePop") &&
                                document.getElementById("multiBalancePop").style.display ===
                                "block") ||
                            (!!document.getElementById("multiBalancePop") &&
                                document.getElementById("multiBalancePop").style.display ===
                                "block") ||
                            (!!document.getElementById("multiRGBalancePop") &&
                                document.getElementById("multiRGBalancePop").style.display ===
                                "block")
                        ) {
                            document.getElementById("multiBalancePop").style.display = "none";
                            document.getElementById("multiRGBalancePop").style.display =
                                "none";
                            document.getElementById("account_pop").style.display = "none";
                        }
                    } else {
                        if (
                            document.getElementById("account_pop").style.display === "block"
                        ) {
                            document.getElementById("account_pop").style.display = "none";
                        }
                    }
                }
            });
        }

        // if (!userData || !userData.sub) {
        //   window.location.href = "/";
        // } else 

        if (!!userData && userData.pwdch) {
            // window.location.href = "/setpassword";
            this.setState({ pwdch: true }, () => {
                this.showPopup("Login");
            });
        } else {
            let sptCount = localStorage.getItem("liveSportCount");
            if (!!sptCount) {
                sptCount = JSON.parse(sptCount);
                this.setState({
                    cktInplay: sptCount.cktInplay,
                    socInplay: sptCount.socInplay,
                    tenInplay: sptCount.tenInplay,
                    kbdInplay: sptCount.kbdInplay,
                    electInplay: sptCount.electInplay,
                    horsInplay: sptCount.horsInplay,
                    houndInplay: sptCount.houndInplay,
                });
            }
            this.setState(
                { uid: !!userData ? userData.sub : "", accessControl: accessControl },
                async () => {
                    if (!!accData && Object.keys(accData).length > 0) {
                        this.loadData();
                    }
                    // if(casinoPages.includes(window.location.pathname) && !!hmdt){
                    if (!pathMarketToLoadFirst.includes(window.location.pathname)) {
                        const hmdt = JSON.parse(localStorage.getItem("homeData"));
                        if (!!hmdt) {
                            // && !pathMarketToLoadFirst.includes(window.location.pathname)){
                            this.loadEvtData(hmdt);
                            loadEvtDataSetTimeOut = setTimeout(() => {
                                clearTimeout(loadEvtDataSetTimeOut);
                                this.loadEvtData();
                            }, this.state.eventdataloadtimer);
                        } else {
                            this.loadEvtData();
                        }
                    }
                    if (!!this.props.scoreData) {
                    }
                    // socket = this.props.socket
                    // setTimeout(()=>{
                    if (!!accData && Object.keys(accData).length > 0) {
                        if (
                            !!this.props.subscriptions &&
                            this.props.subscriptions.user_room.indexOf(userData.sub) === -1
                        ) {
                            socket.emit("user_room", userData.sub);
                            socket.emit("client_room", userData.sub);
                            this.props.subscribe("user_room", userData.sub);
                            // Sentry.captureMessage(' Socket Connected :- ' + userData.sub )
                        }
                        socket.on("user_room", (data) => {
                            let msg = JSON.parse(data);
                            this.props.notify(msg.message, msg.type);
                        });
                        if (
                            !!this.props.subscriptions &&
                            this.props.subscriptions.site_room.indexOf(userData.sub) === -1
                        ) {
                            socket.emit("site_room", userData.sub);
                            this.props.subscribe("site_room", userData.sub);
                        }
                        socket.on("site_room", async (data) => {
                            let msg = isJsonString(data);// = JSON.parse(data);
                            if (!msg) {
                                return;
                            }
                            let self = this;
                            if (!!msg.command && msg.command === "NotifyMarqueeUpdated") {
                                this.setState({ marquee: msg.payload.message });
                                localStorage.setItem("marquee", msg.payload.message);
                            } else if (!!msg.command && msg.command === "MARQUEE") {
                                let mrq = isJsonString(msg.payload.message);
                                if (!mrq) {
                                    return;
                                }
                                this.setState({ marquee: mrq.message });
                                localStorage.setItem("marquee", mrq.message);
                            } else if (!!msg.command && (msg.command === "LOGOUT" || msg.command === "FORCE.LOGOUT")) {
                                // debugger
                                // let accountData = localStorage.getItem("accountData")
                                //     accountData = JSON.parse(accountData)

                                // Sentry.captureMessage('Logout by socket command user: ' + accountData.userId + ' @' + new Date().toISOString() + ' on route: ' + window.location.pathname)
                                // let userData = localStorage.getItem("tokenData");
                                if (!!userData && userData.role === "DemoClient" && msg.command === "LOGOUT") {
                                    return false;
                                }
                                authUtil.logout(true);
                            } else if (!!msg.command && msg.command === "USER.DEPOSIT") {
                                const isSuccess = msg.payload.isSuccess;
                                const mmsg = msg.payload.message;
                                const msgamount = msg.payload.amount;
                                if (isSuccess) {
                                    this.props.notify(`Amount ${msgamount} credited to your balance. 🤑`, "success");
                                } else {
                                    this.props.notify(`Payment request of ${msgamount} is rejected (Reason : ${mmsg}). 😢`, "error");
                                }
                            } else if (!!msg.command && msg.command === "USER.BALANCE") {
                                let accData = self.state.accountData
                                Object.keys(msg.payload).forEach((elem, i) => {
                                    accData[elem] = msg.payload[elem]
                                })
                                if (!!accData.username) {
                                    if (accData.userLock) {
                                        self.logout()
                                    }
                                    self.setState({ accountData: { ...accData } }, () => {
                                        self.setState({ accountData: accData }, () => {
                                            localStorage.setItem("accountData", JSON.stringify(accData))
                                        })
                                    })
                                }
                            }

                            if (
                                !!msg.command &&
                                (msg.command === "RESULTDECLARED" ||
                                    msg.command === "BINARYRESULTDECLARED") &&
                                msg.payload.username === userData.sub
                            ) {
                                if (!!this.props.resultDeclered) {
                                    this.props.resultDeclered("market", msg.payload);
                                }
                                if (msg.payload.pnl > 0) {
                                    this.props.notify(
                                        "Congratulations! You WON " +
                                        msg.payload.pnl +
                                        " from your bets on " +
                                        msg.payload.marketName +
                                        ". 🤑",
                                        "success"
                                    );
                                } else if (msg.payload.pnl < 0) {
                                    this.props.notify(
                                        "Oops! You lost " +
                                        msg.payload.pnl +
                                        " from your bets on " +
                                        msg.payload.marketName +
                                        ". 😢",
                                        "error"
                                    );
                                }
                            }
                            // if (!!msg.command && (msg.command === "SPORTSBETPLACED" || msg.command === "BINARYBETPLACED")) {
                            //     if (!!this.props.orderPlaced) {
                            //         this.props.orderPlaced(msg.payload)
                            //     }
                            // }
                            if (
                                !!msg.command &&
                                (msg.command === "VOIDORDER" || msg.command === "BINARYVOIDORDER")
                            ) {
                                if (!!this.props.resultDeclered) {
                                    this.props.resultDeclered("order", msg.payload);
                                }
                                if (msg.payload.pnl > 0) {
                                    this.props.notify(
                                        "Your account has been credited with " +
                                        msg.payload.pnl +
                                        " because of rollback in " +
                                        msg.payload.marketName +
                                        ".",
                                        "success"
                                    );
                                } else if (msg.payload.pnl < 0) {
                                    this.props.notify(
                                        "Your account has been debited with " +
                                        msg.payload.pnl +
                                        " due to rollback in " +
                                        msg.payload.marketName +
                                        ".",
                                        "error"
                                    );
                                }
                            }
                            if (
                                !!msg.command &&
                                (msg.command === "RESULTROLLBACK" ||
                                    msg.command === "BINARYRESULTROLLBACK")
                            ) {
                                if (!!this.props.resultDeclered) {
                                    this.props.resultDeclered("rollback", msg.payload);
                                }
                            } else if (
                                !!msg.command &&
                                msg.command === "Orders.NotifyVoidSportsMarket"
                            ) {
                                if (!!this.props.resultDeclered) {
                                    this.props.resultDeclered("market", msg.payload);
                                }
                            }
                            if (
                                !!msg.command &&
                                (msg.command === "SPORTSMARKETVOID" ||
                                    msg.command === "BINARYMARKETVOID")
                            ) {
                                if (!!this.props.resultDeclered) {
                                    this.props.resultDeclered("market", msg.payload);
                                    this.props.notify(
                                        " Market " + msg.payload.marketName + " is Voided !",
                                        "error"
                                    );
                                }
                            } else if (!!msg.command) {
                                let homeDataLs = JSON.parse(localStorage.getItem("homeData"));
                                if (msg.command.includes("EVT.HB.")) {
                                    let evtId = msg.payload.eventId;
                                    homeDataLs.forEach((mkt, i) => {
                                        if (mkt.event.id === evtId) {
                                            homeDataLs[i].metadata.eventMeta.hasBookMaker = msg.payload
                                                .hasBookMaker
                                                ? "true"
                                                : "false";
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("EVT.HS.")) {
                                    let evtId = msg.payload.eventId;
                                    homeDataLs.forEach((mkt, i) => {
                                        if (mkt.event.id === evtId) {
                                            homeDataLs[i].metadata.eventMeta.hasSession = msg.payload
                                                .hasSession
                                                ? "true"
                                                : "false";
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("EVT.HT.")) {
                                    let evtId = msg.payload.eventId;
                                    homeDataLs.forEach((mkt, i) => {
                                        if (mkt.event.id === evtId) {
                                            homeDataLs[i].metadata.eventMeta.hasTv = msg.payload.hasTv
                                                ? "true"
                                                : "false";
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("MKT.IMP")) {
                                    let mktdata = msg.payload.marketDetails.filter((elm) => {
                                        return elm.recordType === "MARKET";
                                    })[0];
                                    homeDataLs.push(mktdata);
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("MKT.IS.")) {
                                    let mktId = msg.payload.marketId;
                                    if (msg.payload.marketInPlayStatus === 256) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.status = "INACTIVE";
                                            }
                                        });
                                    } else if (msg.payload.marketInPlayStatus === 257) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.status = "OPEN";
                                            }
                                        });
                                    } else if (msg.payload.marketInPlayStatus === 258) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.status = "SUSPENDED";
                                            }
                                        });
                                    } else if (msg.payload.marketInPlayStatus === 259) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.status = "CLOSED";
                                            }
                                        });
                                    } else if (msg.payload.marketInPlayStatus === 1) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.inPlay = false;
                                            }
                                        });
                                    } else if (msg.payload.marketInPlayStatus === 2) {
                                        homeDataLs.forEach((elem, i) => {
                                            if (elem.catalogue.marketId === mktId) {
                                                homeDataLs[i].catalogue.inPlay = true;
                                            }
                                        });
                                    }
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("CMP.A.")) {
                                    homeDataLs.forEach((elem, i) => {
                                        if (elem.competition.id === msg.payload.competitionId) {
                                            homeDataLs[i].competition.isActive = true;
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("CMP.DA.")) {
                                    homeDataLs.forEach((elem, i) => {
                                        if (elem.competition.id === msg.payload.competitionId) {
                                            homeDataLs[i].competition.isActive = false;
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("EVT.A.")) {
                                    homeDataLs.forEach((elem, i) => {
                                        if (elem.event.id === msg.payload.eventId) {
                                            homeDataLs[i].event.isActive = true;
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("EVT.DA.")) {
                                    homeDataLs.forEach((elem, i) => {
                                        if (elem.event.id === msg.payload.eventId) {
                                            homeDataLs[i].event.isActive = false;
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                } else if (msg.command.includes("EVT.T.")) {
                                    homeDataLs.forEach((elem, i) => {
                                        if (elem.event.id === msg.payload.eventId) {
                                            homeDataLs[i].event.openDate = msg.payload.newTime;
                                        }
                                    });
                                    localStorage.setItem("homeData", JSON.stringify(homeDataLs));
                                    this.updateEventData(homeDataLs);
                                }
                            }

                            if (!!msg.command && msg.command === "NOTIFICATION") {
                                if(self.state.clientWidth > 768) {
                                    self.setState({ notificationCount: self.state.notificationCount + 1 });
                                } else {
                                    document.getElementById('iIncreaseNotificationCount').click();
                                }
                                self.props.notify(
                                    <div>
                                        <h5 className="text-black font-bold">{msg.payload.title}</h5>
                                        <div dangerouslySetInnerHTML={{ __html: msg.payload.body }} />
                                    </div>,
                                    'info',
                                    {theme: "light"}
                                );
                                if(window.location.pathname === '/notifications'){
                                    self.props.updateNotiList(msg.payload);
                                }
                            } 

                            
                        });
                        const prfdt = JSON.parse(localStorage.getItem('profData'));
                        if (!!prfdt && prfdt.role === 'DemoClient') {
                            socket.emit("demo_room", userData.sub);
                            socket.on("demo_room", async (data) => {
                                let msg = JSON.parse(data);
                                let self = this;
                                if (!!msg.command && msg.command === "MARKET_RESULT") {
                                    let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                                    demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : {};

                                    let demoExpo = JSON.parse(sessionStorage.getItem('demoExpo'));
                                    // demoExpo = !!demoExpo ? JSON.parse(demoExpo) : null;

                                    let demoPnL = sessionStorage.getItem('demoPnL');
                                    demoPnL = !!demoPnL ? parseFloat(demoPnL) : 0;
                                    let betevent;
                                    let betindex = -1;
                                    let splicedBet;
                                    let dmpl = 0;
                                    if (Object.keys(demoIdSsData).length > 0) {
                                        Object.keys(demoIdSsData).forEach((itmm, id) => {
                                            demoIdSsData[itmm].forEach((itm, i) => {
                                                if (itm.marketId === msg.payload.message.marketId) {
                                                    betevent = itm.eventId;
                                                    betindex = i;
                                                }
                                            })
                                        })
                                    }

                                    if (betindex > -1) {
                                        splicedBet = demoIdSsData[betevent].splice(betindex, 1);
                                        splicedBet = splicedBet[0];
                                        if (splicedBet.marketBettingType === "LINE") {
                                            let mul = splicedBet.side === "BACK" ? (parseInt(msg.payload.message.winnerId) >= parseInt(splicedBet.runnerId) ? -1 : 1) : (parseInt(msg.payload.message.winnerId) < parseInt(splicedBet.runnerId) ? -1 : 1);
                                            dmpl = parseFloat(demoExpo[splicedBet.marketId]) * mul;
                                        } else if (splicedBet.marketBettingType === "BOOKMAKER" || splicedBet.marketBettingType === "SPECIAL_MAKER" || splicedBet.marketBettingType === "MINI_BOOKMAKER" || splicedBet.marketBettingType === "MINI_MATCH_ODDS") {
                                            if (splicedBet.side === "BACK") {
                                                if (msg.payload.message.winnerId === splicedBet.runnerId) {
                                                    dmpl = ((parseFloat(splicedBet.price)) * parseFloat(splicedBet.amount)) / 100
                                                } else {
                                                    dmpl = (0 - parseFloat(splicedBet.amount))
                                                }
                                            } else if (splicedBet.side === "LAY") {
                                                if (msg.payload.message.winnerId === splicedBet.runnerId) {
                                                    dmpl = (0 - ((parseFloat(splicedBet.price)) * parseFloat(splicedBet.amount))) / 100
                                                } else {
                                                    dmpl = parseFloat(splicedBet.amount);
                                                }
                                            }
                                        } else {
                                            if (splicedBet.side === "BACK") {
                                                if (msg.payload.message.winnerId === splicedBet.runnerId) {
                                                    dmpl = (parseFloat(splicedBet.price) - 1) * parseFloat(splicedBet.amount);
                                                } else {
                                                    dmpl = (0 - parseFloat(splicedBet.amount));
                                                }
                                            } else if (splicedBet.side === "LAY") {
                                                if (msg.payload.message.winnerId === splicedBet.runnerId) {
                                                    dmpl = (0 - ((parseFloat(splicedBet.price) - 1) * parseFloat(splicedBet.amount)))
                                                } else {
                                                    dmpl = parseFloat(splicedBet.amount);
                                                }
                                            }
                                        }
                                        delete demoExpo[splicedBet.marketId]
                                        demoPnL = demoPnL + dmpl;
                                    }

                                    sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
                                    sessionStorage.setItem('demoExpo', JSON.stringify(demoExpo));
                                    sessionStorage.setItem('demoPnL', demoPnL);
                                    this.refreshDemoBalExpo()
                                    // msg.payload
                                } else if (!!msg.command && msg.command === "MARKET_VOID") {
                                    let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                                    demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : null;

                                    let demoExpo = JSON.parse(sessionStorage.getItem('demoExpo'));
                                    // demoExpo = !!demoExpo ? JSON.parse(demoExpo) : null;

                                    let betevent;
                                    let betindex = -1;
                                    let splicedBet;
                                    if (Object.keys(demoIdSsData).length > 0) {
                                        Object.keys(demoIdSsData).forEach((itmm, id) => {
                                            demoIdSsData[itmm].forEach((itm, i) => {
                                                if (itm.marketId === msg.payload.message.marketId) {
                                                    betevent = itm.eventId;
                                                    betindex = i;
                                                }
                                            })
                                        })
                                    }

                                    if (!!betindex && betindex > -1) {
                                        splicedBet = demoIdSsData[betevent].splice(betindex, 1);
                                        delete demoExpo[splicedBet.marketId]
                                    }

                                    sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
                                    sessionStorage.setItem('demoExpo', JSON.stringify(demoExpo));
                                    this.refreshDemoBalExpo()
                                }
                            })
                        } else {
                            if(this.state.clientWidth > 768) {
                                this.getNotifications();
                            }
                        }
                        socket.on("disconnect", () => {
                            // Sentry.captureMessage(' Socket Disconnected :- ' + userData.sub )

                            // eslint-disable-next-line no-restricted-globals
                            location.reload();
                            // Object.keys(this.props.subscriptions).forEach((type, i) => {
                            //     this.props.subscriptions[type].forEach((elem) => {
                            //         socket.emit(type, elem)
                            //     })
                            // })
                        });
                    }
                    // },2000)
                }
            );
        }
    }

    getNotifications() {
        const data = `fromDate=${moment().subtract(1, 'day').startOf('day').toISOString()}&toDate=${moment().add(1, 'day').endOf('day').toISOString()}`;
        getNotification(data).then((res) => {
            if (res && res.isSuccess === true) {
                this.setState({ notificationCount: res.items.length });
            }
        });
    }

    componentWillReceiveProps() {
        let self = this;
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (
            !!this.props.scoreData &&
            this.props.scoreData !== this.state.scoreDetail &&
            (!!accData && Object.keys(accData).length > 0)
        ) {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.scoreDetail = this.props.scoreData;
            if (!!this.props.scoreData.type && this.props.scoreData.type !== "4") {
                if (
                    this.props.subscriptions.x_score_room.indexOf(
                        this.props.scoreData.evtId
                    ) === -1
                ) {
                    socket.emit("x_score_room", this.props.scoreData.evtId);
                    this.props.subscribe("x_score_room", this.props.scoreData.evtId);
                }
                socket.on("x_score_room", (data) => {
                    self.props.updateXScore(data);
                });
            } else if (
                !!this.props.scoreData.type &&
                this.props.scoreData.type === "4"
            ) {
                if (
                    this.props.subscriptions.score_room.indexOf(
                        this.props.scoreData.evtId
                    ) === -1
                ) {
                    socket.emit("score_room", this.props.scoreData.evtId);
                    this.props.subscribe("score_room", this.props.scoreData.evtId);
                }
                socket.on("score_room", (data) => {
                    self.props.onMessage(data);
                });
            }
        }
        if (this.props.updateHomeData) {
            const homeDataLs = JSON.parse(localStorage.getItem("homeData"));
            this.updateEventData(homeDataLs);
            // this.loadEvtData(homeDataLs);
        }
    }

    async componentDidUpdate() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if ((!!accData && Object.keys(accData).length > 0) && this.props.betPlaced) {
            this.props.updateBetplaceStatus();
            // let accData = await accountServices.getAccountData();
            // if (!!accData.username) {
            //   if (accData.userLock) {
            //     authUtil.logout();
            //   }
            //   this.setState({ accountData: accData });
            //   localStorage.setItem("accountData", JSON.stringify(accData));
            // }
            // let self = this;
            // clearInterval(accCall);
            // accCall = setInterval(async function accountCall() {
            //   clearInterval(accCall);
            //   let accData = await accountServices.getAccountData();
            //   if (!!accData.username) {
            //     if (accData.userLock) {
            //       authUtil.logout();
            //     }
            //     self.setState({ accountData: accData }, () => {
            //       localStorage.setItem("accountData", JSON.stringify(accData));
            //     });
            //   }
            //   accCall = setInterval(accountCall, 60000);
            // }, 60000);

        }
    }

    componentWillUnmount() {
        clearInterval(dataIntervalCall);
        clearInterval(accCall);
        clearInterval(evtData);
        clearTimeout(mqTime);
        clearTimeout(loadEvtDataSetTimeOut);
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
            if (!!this.props.socket) {
                this.props.socket.off("user_room");
                this.props.socket.off("site_room");
                this.props.socket.off("score_room");
                this.props.socket.off("x_score_room");
                this.props.socket.off("demo_room");
            }
        }
    }


    async loadProfileData() {
        let profData = await accountServices.getProfileData(this.state.uid);//localStorage.getItem('profData');
        if (!profData.username) {
            return false;
        }
        // if(!!profData){
        //     profData = JSON.parse(profData);
        // }
        // profData = JSON.stringify(profData)
        // localStorage.setItem("profData", profData)//await accountServices.getProfileData(this.state.uid);
        // const showevolution = profData.parents.indexOf('office') > -1;//profData.parents[profData.parents.length - 2] === 'office';
        // this.setState({showevolution : showevolution})

        let accData = {
            "personName": profData.username,
            "balance": profData.balance,
            "exposure": profData.exposure,
            "pnl": profData.upLineBalance,
            "minBet": profData.minBet,
            "maxBet": profData.maxBet,
            "maxProfit": profData.maxProfit,
            "betDelay": profData.betDelay,
            "betLock": profData.maxBet,
            "userLock": !profData.isActive,
            "operatorId": profData.operatorId,
            "username": profData.username,
            "currency": profData.currency,
            "currencyConversion": profData.currencyConversion,
            "userId": profData.userId
        }

        if (!!profData && profData.role === 'DemoClient') {
            let demoExpo = sessionStorage.getItem('demoExpo')
            let demopl = sessionStorage.getItem('demoPnL')
            if (!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0) {
                demoExpo = JSON.parse(demoExpo);
                let totalexpo = (Object.values(demoExpo).reduce((a, v) => a = a + v, 0))

                // accData["balance"] = profData.balance + totalexpo;
                accData["exposure"] = totalexpo;
                accData["pnl"] = !!demopl ? demopl : 0;
            }
        }

        if (!!accData.username) {
            if (accData.userLock) {
                this.logout()

            }
            this.setState({ accountData: accData })
            localStorage.setItem("accountData", JSON.stringify(accData))
        }
        if ((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) {
            let rgAccData = await realGamesService.getRealGamesUserBalance(accData.username)

            if (!!rgAccData && !!rgAccData.username) {
                this.setState({ rgAccountData: rgAccData })
                localStorage.setItem("realGamesAccountData", JSON.stringify(rgAccData))
            }
        }
        let self = this

        clearInterval(accCall)
        clearInterval(evtData)
        let sptCount = localStorage.getItem("liveSportCount");
        if (!!sptCount) {
            sptCount = JSON.parse(sptCount);
            this.setState({
                cktInplay: sptCount.cktInplay,
                socInplay: sptCount.socInplay,
                tenInplay: sptCount.tenInplay,
                kbdInplay: sptCount.kbdInplay,
                electInplay: sptCount.electInplay,
                horsInplay: sptCount.horsInplay,
                houndInplay: sptCount.houndInplay,
            });
        }

        accCall = setInterval(async function accountCall() {
            clearInterval(accCall)
            let sptCount = localStorage.getItem("liveSportCount");
            if (!!sptCount) {
                sptCount = JSON.parse(sptCount);
                self.setState({
                    cktInplay: sptCount.cktInplay,
                    socInplay: sptCount.socInplay,
                    tenInplay: sptCount.tenInplay,
                    kbdInplay: sptCount.kbdInplay,
                    electInplay: sptCount.electInplay,
                    horsInplay: sptCount.horsInplay,
                    houndInplay: sptCount.houndInplay,
                });
            }
            // let accData = await accountServices.getAccountData()
            // if (!!accData.username) {
            //     if (accData.userLock) {
            //         self.logout()
            //     }
            //     self.setState({ accountData: accData }, () => {
            //         localStorage.setItem("accountData", JSON.stringify(accData))
            //     })
            // }

            if ((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) {
                let rgAccData = await realGamesService.getRealGamesUserBalance(accData.username)
                if (!!rgAccData && !!rgAccData.username) {
                    self.setState({ rgAccountData: rgAccData })
                    localStorage.setItem("realGamesAccountData", JSON.stringify(rgAccData))
                }
            }

            accCall = setInterval(accountCall, !casinoPages.includes(window.location.pathname) ? 60000 : 10000)

        }, !casinoPages.includes(window.location.pathname) ? 60000 : 10000)
        const isOfficeChannel = profData?.username === 'office' || profData?.parents?.includes('office');
        profData = JSON.stringify(profData)
        localStorage.setItem("profData", profData)
        this.setState({
            isOfficeChannel: isOfficeChannel
        });
    }

    refreshDemoBalExpo() {
        const profData = JSON.parse(localStorage.getItem('profData'));
        if (!!profData && profData.role === 'DemoClient') {
            let accData = {
                "personName": profData.username,
                "balance": profData.balance,
                "exposure": profData.exposure,
                "pnl": profData.upLineBalance,
                "minBet": profData.minBet,
                "maxBet": profData.maxBet,
                "maxProfit": profData.maxProfit,
                "betDelay": profData.betDelay,
                "betLock": profData.maxBet,
                "userLock": !profData.isActive,
                "operatorId": profData.operatorId,
                "username": profData.username,
                "currency": profData.currency,
                "currencyConversion": profData.currencyConversion,
                "userId": profData.userId
            }

            let demoExpo = sessionStorage.getItem('demoExpo')
            let demopl = sessionStorage.getItem('demoPnL')
            if (!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0) {
                demoExpo = JSON.parse(demoExpo);
                let totalexpo = (Object.values(demoExpo).reduce((a, v) => a = a + v, 0))

                // accData["balance"] = profData.balance + totalexpo;
                accData["exposure"] = totalexpo;
                accData["pnl"] = !!demopl ? demopl : 0;
            }
            localStorage.setItem("accountData", JSON.stringify(accData))
            this.setState({ accountData: accData });
        }
    }

    async loadData() {
        let data = localStorage.getItem("accountData")
        data = JSON.parse(data)
        const profData = JSON.parse(localStorage.getItem("profData"));
        if (!!profData && profData.role === 'DemoClient') {
            let demoExpo = sessionStorage.getItem('demoExpo')
            let demopl = sessionStorage.getItem('demoPnL')
            if (!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0) {
                demoExpo = JSON.parse(demoExpo);
                let totalexpo = (Object.values(demoExpo).reduce((a, v) => a = a + v, 0))

                // accData["balance"] = profData.balance + totalexpo;
                data["exposure"] = totalexpo;
                data["pnl"] = !!demopl ? demopl : 0;
            }
        }
        this.setState({ accountData: data })
        // let rgdata = localStorage.getItem("realGamesAccountData")
        // rgdata = JSON.parse(rgdata)
        // this.setState({ rgAccountData: rgdata })

        // this.loadEvtData(true)
        this.loadProfileData()

        // let accData = await accountServices.getAccountData()
        // if (!!accData.username) {
        //     if (accData.userLock) {
        //         this.logout()

        //     }
        //     this.setState({ accountData: accData })
        //     localStorage.setItem("accountData", JSON.stringify(accData))
        // }
        // debugger

        // if((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show){
        //     let rgAccData = await realGamesService.getRealGamesUserBalance(accData.username)

        //     if (!!rgAccData && !!rgAccData.username) {
        //         this.setState({ rgAccountData: rgAccData })
        //         localStorage.setItem("realGamesAccountData", JSON.stringify(rgAccData))
        //     }
        // }

        // let self = this

        // clearInterval(accCall)
        // clearInterval(evtData)

        // accCall = setInterval(async function accountCall() {
        //     clearInterval(accCall)
        //     // let accData = await accountServices.getAccountData()
        //     // if (!!accData.username) {
        //     //     if (accData.userLock) {
        //     //         self.logout()
        //     //     }
        //     //     self.setState({ accountData: accData }, () => {
        //     //         localStorage.setItem("accountData", JSON.stringify(accData))
        //     //     })
        //     // }

        //     if((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show){
        //         let rgAccData = await realGamesService.getRealGamesUserBalance(accData.username)
        //         if (!!rgAccData && !!rgAccData.username) {
        //             self.setState({ rgAccountData: rgAccData })
        //             localStorage.setItem("realGamesAccountData", JSON.stringify(rgAccData))
        //         }
        //     }

        //     accCall = setInterval(accountCall, !casinoPages.includes(window.location.pathname) ? 60000 : 10000)

        // }, !casinoPages.includes(window.location.pathname) ? 60000 : 10000)

        // evtData = setInterval(async function eventData() {
        //     clearInterval(evtData)
        //     self.loadEvtData()
        //     evtData = setInterval(eventData, eventPages.includes(window.location.pathname) ? 15000 : 60000)
        // }, eventPages.includes(window.location.pathname) ? 15000 : 60000)
    }
    parseBook(data) {
        !!data &&
            data.length > 0 &&
            data.forEach((mkt, i) => {
                // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
                let eventMeta = {};
                eventMeta.hasBookMaker =
                    !!mkt.metadata &&
                        !!mkt.metadata.hasBookMaker &&
                        mkt.metadata.hasBookMaker === "True"
                        ? "true"
                        : "false";
                eventMeta.hasSession =
                    !!mkt.metadata &&
                        !!mkt.metadata.hasSession &&
                        mkt.metadata.hasSession === "True"
                        ? "true"
                        : "false";
                eventMeta.hasTv =
                    !!mkt.metadata &&
                        !!mkt.metadata.hasTv &&
                        mkt.metadata.hasTv === "True"
                        ? "true"
                        : "false";
                let book =
                    !!mkt.metadata && !!mkt.metadata.book
                        ? stringParser.deSrlz(mkt.metadata.book)
                        : null;
                if (mkt.eventType.id === "300") {
                    data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(
                        mkt.catalogue.marketName
                    );
                    data[i].symbolType =
                        !!mkt.metadata && !!mkt.metadata.symbol_type
                            ? mkt.metadata.symbol_type
                            : null;
                    data[i].eventId = mkt.event.id;
                    data[i].eventName = mkt.event.name;
                    data[i].competitionName = mkt.competition.name;
                }
                // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
                data[i].metadata = {};
                data[i].metadata.book = book;
                data[i].metadata.eventMeta = eventMeta;
                // if(!!market_end_time){
                //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
                //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
                // }
            });
        return data;
    }

    updateEventData(homeData) {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        let userEventCktData = [];
        let userEventSocData = [];
        let userEventTenData = [];
        let userEventKbdData = [];
        let userEventElectData = [];
        let userEventHorsData = [];
        let userEventHoundData = [];
        let userEventBinaryData = [];
        for (let mkt of homeData) {
            if (mkt.competition.isActive === false || mkt.event.isActive === false) {
                // console.log(mkt)
            } else if (mkt.eventType.id === "4") {
                userEventCktData.push(mkt);
            } else if (mkt.eventType.id === "1") {
                userEventSocData.push(mkt);
            } else if (mkt.eventType.id === "2") {
                userEventTenData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && mkt.eventType.id === "400") {
                userEventKbdData.push(mkt);
            } else if (mkt.eventType.id === "7") {
                userEventHorsData.push(mkt);
            } else if (mkt.eventType.id === "4339") {
                userEventHoundData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && mkt.eventType.id === "500") {
                userEventElectData.push(mkt);
            } else if (showBinary && mkt.eventType.id === "300") {
                userEventBinaryData.push(mkt);
            }
            // else if (mkt.eventType.id === "500") {
            //     userEventElectData.push(mkt)
            // }
        }
        if (!!this.props.getEvtData) {
            this.props.getEvtData(
                userEventCktData,
                userEventSocData,
                userEventTenData,
                userEventKbdData,
                userEventElectData,
                userEventHorsData,
                userEventHoundData,
                userEventBinaryData
            );
        }
        // let cktInplay = this.countLiveEvt(userEventCktData);
        // let socInplay = this.countLiveEvt(userEventSocData);
        // let tenInplay = this.countLiveEvt(userEventTenData);
        // let kbdInplay = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true ? this.countLiveEvt(userEventKbdData) : 0;
        // let electInplay = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true ? this.countLiveEvt(userEventElectData) : 0;
        // let horsInplay = this.countLiveEvt(userEventHorsData);
        // let houndInplay = this.countLiveEvt(userEventHoundData);
        // let binaryInplay = showBinary ? this.countLiveEvt(userEventBinaryData) : 0;
        // let sptCount = localStorage.getItem("liveSportCount");
        // if (!!sptCount) {
        //     sptCount = JSON.parse(sptCount);
        // }
        // this.setState(
        //     {
        //         cktInplay: sptCount.cktInplay || cktInplay,
        //         socInplay: sptCount.socInplay || socInplay,
        //         tenInplay: sptCount.tenInplay || tenInplay,
        //         kbdInplay: sptCount.kbdInplay || kbdInplay,
        //         electInplay: sptCount.electInplay || electInplay,
        //         horsInplay: sptCount.horsInplay || horsInplay,
        //         houndInplay: sptCount.houndInplay || houndInplay,
        //         binaryInplay: sptCount.binaryInplay || binaryInplay,
        //     },
        //     () => {
        //         let countData = {
        //             cktInplay: cktInplay,
        //             socInplay: socInplay,
        //             tenInplay: tenInplay,
        //             kbdInplay: kbdInplay,
        //             electInplay: electInplay,
        //             horsInplay: horsInplay,
        //             houndInplay: houndInplay,
        //             binaryInplay: binaryInplay,
        //         };
        //         // localStorage.setItem("liveSportCount", JSON.stringify(countData));
        //     }
        // );
    }

    // async loadEvtData(isFirstCall) {
    async loadEvtDataBkp(homeDtLs) {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        let homeData = [];
        // debugger
        // if (isFirstCall) {
        //     let homeDataLs = JSON.parse(localStorage.getItem("homeData"))
        //     if (!!homeDataLs && homeDataLs.length > 0) {
        //         homeData = homeDataLs
        //     } else {
        //         if(!casinoPages.includes(window.location.pathname)){
        //             homeData = await eventServices.getHomeData()
        //             homeData = this.parseBook(homeData)
        //         }
        //     }
        // } else {
        //     // debugger
        //     if(!casinoPages.includes(window.location.pathname)){
        //          homeData = await eventServices.getHomeData()
        //          homeData = this.parseBook(homeData)
        //     }
        // }
        //let homeDataLs = !!homeDtLs ? homeDtLs : JSON.parse(localStorage.getItem("homeData"))
        let isBaseData = localStorage.getItem("isBaseData");
        if (!!homeDtLs && homeDtLs.length > 0) {
            homeData = homeDtLs;
        } else {
            // if(!casinoPages.includes(window.location.pathname)){
            homeData = await eventServices.getBaseHomeData();
            if (Array.isArray(homeData) && homeData.length > 0) {
                homeData = this.parseBook(homeData);
            } else {
                homeData = [];
            }
            // }
        }

        // if(!!this.state.accountData && Object.keys(this.state.accountData).length > 0){
        localStorage.setItem("homeData", JSON.stringify(homeData));
        // }
        if (!homeData) {
            return false;
        }
        let userEventCktData = [];
        let userEventSocData = [];
        let userEventTenData = [];
        let userEventKbdData = [];
        let userEventElectData = [];
        let userEventHorsData = [];
        let userEventHoundData = [];
        let userEventBinaryData = [];
        for (let mkt of homeData) {
            if (mkt.eventType.id === "4") {
                userEventCktData.push(mkt);
            } else if (mkt.eventType.id === "1") {
                userEventSocData.push(mkt);
            } else if (mkt.eventType.id === "2") {
                userEventTenData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && mkt.eventType.id === "400") {
                userEventKbdData.push(mkt);
            } else if (mkt.eventType.id === "7") {
                userEventHorsData.push(mkt);
            } else if (mkt.eventType.id === "4339") {
                userEventHoundData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && mkt.eventType.id === "500") {
                userEventElectData.push(mkt);
            } else if (showBinary && mkt.eventType.id === "300") {
                userEventBinaryData.push(mkt);
            }
        }
        if (!!this.props.getEvtData) {
            this.props.getEvtData(
                userEventCktData,
                userEventSocData,
                userEventTenData,
                userEventKbdData,
                userEventElectData,
                userEventHorsData,
                userEventHoundData,
                userEventBinaryData
            );
        }
        // let cktInplay = this.countLiveEvt(userEventCktData);
        // let socInplay = this.countLiveEvt(userEventSocData);
        // let tenInplay = this.countLiveEvt(userEventTenData);
        // let kbdInplay = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true ? this.countLiveEvt(userEventKbdData) : 0;
        // let electInplay = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true ? this.countLiveEvt(userEventElectData) : 0;
        // let horsInplay = this.countLiveEvt(userEventHorsData);
        // let houndInplay = this.countLiveEvt(userEventHoundData);
        // let binaryInplay = showBinary ? this.countLiveEvt(userEventBinaryData) : 0;
        // this.setState(
        //     {
        //         cktInplay: cktInplay,
        //         socInplay: socInplay,
        //         tenInplay: tenInplay,
        //         kbdInplay: kbdInplay,
        //         electInplay: electInplay,
        //         horsInplay: horsInplay,
        //         houndInplay: houndInplay,
        //         binaryInplay: binaryInplay,
        //     },
        //     () => {
        //         let countData = {
        //             cktInplay: cktInplay,
        //             socInplay: socInplay,
        //             tenInplay: tenInplay,
        //             kbdInplay: kbdInplay,
        //             electInplay: electInplay,
        //             horsInplay: horsInplay,
        //             houndInplay: houndInplay,
        //             binaryInplay: binaryInplay,
        //         };
        //         // localStorage.setItem("liveSportCount", JSON.stringify(countData));
        //         if (isBaseData === "true") {
        //             localStorage.setItem("isBaseData", "false");
        //             this.loadEvtData();
        //         }
        //     }
        // );
    }
    async loadEvtData(homeDtLs) {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        let homeData = [];
        let isBaseData = localStorage.getItem("isBaseData");
        if (!!homeDtLs && homeDtLs.length > 0) {
            homeData = homeDtLs;
        } else {
            let typeID
            let splitedpath = window.location.pathname.split('/');
            splitedpath.splice(0, 1);
            if (!!splitedpath && splitedpath.length > 0 && splitedpath[0] === 'game') {
                typeID = splitedpath[1];
            }

            if (!!typeID) {
                let prevhomedata = localStorage.getItem("homeData");
                if (!!prevhomedata) {
                    prevhomedata = JSON.parse(prevhomedata);
                    prevhomedata = prevhomedata.filter((itm) => itm.eventType.id !== typeID)
                } else {
                    prevhomedata = []
                }
                homeData = await eventServices.getHomeDataByEventId(typeID)//getHomeData();
                if (Array.isArray(homeData) && homeData.length > 0) {
                    homeData = this.parseBook(homeData);
                } else {
                    homeData = [];
                }
                homeData = [...prevhomedata, ...homeData];
                this.setFormMenu(homeData);
            } else {
                homeData = await eventServices.getBaseHomeData();
                if (Array.isArray(homeData) && homeData.length > 0) {
                    homeData = this.parseBook(homeData);
                } else {
                    homeData = [];
                }
            }
        }
        localStorage.setItem("homeData", JSON.stringify(homeData));
        if (!homeData) {
            return false;
        }
        let userEventCktData = [];
        let userEventSocData = [];
        let userEventTenData = [];
        let userEventKbdData = [];
        let userEventElectData = [];
        let userEventHorsData = [];
        let userEventHoundData = [];
        let userEventBinaryData = [];
        for (let mkt of homeData) {
            if (mkt.eventType.id === "4") {
                userEventCktData.push(mkt);
            } else if (mkt.eventType.id === "1") {
                userEventSocData.push(mkt);
            } else if (mkt.eventType.id === "2") {
                userEventTenData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && mkt.eventType.id === "400") {
                userEventKbdData.push(mkt);
            } else if (mkt.eventType.id === "7") {
                userEventHorsData.push(mkt);
            } else if (mkt.eventType.id === "4339") {
                userEventHoundData.push(mkt);
            } else if (!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && mkt.eventType.id === "500") {
                userEventElectData.push(mkt);
            } else if (showBinary && mkt.eventType.id === "300") {
                userEventBinaryData.push(mkt);
            }
        }
        if (!!this.props.getEvtData) {
            this.props.getEvtData(
                userEventCktData,
                userEventSocData,
                userEventTenData,
                userEventKbdData,
                userEventElectData,
                userEventHorsData,
                userEventHoundData,
                userEventBinaryData
            );
        }
        // let cktInplay = this.countLiveEvt(userEventCktData);
        // let socInplay = this.countLiveEvt(userEventSocData);
        // let tenInplay = this.countLiveEvt(userEventTenData);
        // let kbdInplay = !!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true ? this.countLiveEvt(userEventKbdData) : 0;
        // let electInplay = !!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true ? this.countLiveEvt(userEventElectData) : 0;
        // let horsInplay = this.countLiveEvt(userEventHorsData);
        // let houndInplay = this.countLiveEvt(userEventHoundData);
        // let binaryInplay = showBinary ? this.countLiveEvt(userEventBinaryData) : 0;
        // this.setState(
        //     {
        //         cktInplay: cktInplay,
        //         socInplay: socInplay,
        //         tenInplay: tenInplay,
        //         kbdInplay: kbdInplay,
        //         electInplay: electInplay,
        //         horsInplay: horsInplay,
        //         houndInplay: houndInplay,
        //         binaryInplay: binaryInplay,
        //     },
        //     () => {
        //         let countData = {
        //             cktInplay: cktInplay,
        //             socInplay: socInplay,
        //             tenInplay: tenInplay,
        //             kbdInplay: kbdInplay,
        //             electInplay: electInplay,
        //             horsInplay: horsInplay,
        //             houndInplay: houndInplay,
        //             binaryInplay: binaryInplay,
        //         };
        //         // localStorage.setItem("liveSportCount", JSON.stringify(countData));
        //         if (isBaseData === "true") {
        //             localStorage.setItem("isBaseData", "false");
        //             this.loadEvtData();
        //         }
        //     }
        // );
        let sptCount = localStorage.getItem("liveSportCount");
        if (!!sptCount) {
            sptCount = JSON.parse(sptCount);
            this.setState({
                cktInplay: sptCount.cktInplay,
                socInplay: sptCount.socInplay,
                tenInplay: sptCount.tenInplay,
                kbdInplay: sptCount.kbdInplay,
                electInplay: sptCount.electInplay,
                horsInplay: sptCount.horsInplay,
                houndInplay: sptCount.houndInplay,
            }, () => {
                if (isBaseData === "true") {
                    localStorage.setItem("isBaseData", "false");
                    this.loadEvtData();
                }
            });
        }
    }
    setFormMenu(evtdt) {
        let evtdataformenu = {
            '1': {},
            '2': {},
            '4': {},
            '7': {},
            '4339': {},
            '400': {},
            '500': {}
        };
        if (!!evtdt) {
            evtdt.forEach((itm) => {
                if (!(!!evtdataformenu[itm.eventType.id][itm.competition.id])) {
                    evtdataformenu[itm.eventType.id][itm.competition.id] = {};
                    evtdataformenu[itm.eventType.id][itm.competition.id].competitionId = itm.competition.id;
                    evtdataformenu[itm.eventType.id][itm.competition.id].competitionName = itm.competition.name;
                    evtdataformenu[itm.eventType.id][itm.competition.id].events = []
                }
                let arrIds = evtdataformenu[itm.eventType.id][itm.competition.id].events.map((elem) => { return elem = elem.id })
                if (!arrIds.includes(itm.id)) {
                    evtdataformenu[itm.eventType.id][itm.competition.id].events.push(itm.event);
                }
            })

            localStorage.setItem('eventMenuDetails', JSON.stringify(evtdataformenu));
        }
    }
    countLiveEvt(evts) {
        let userEventData = evts;
        let events = [];
        !!userEventData &&
            userEventData.length > 0 &&
            userEventData.forEach((mkt, i) => {
                if (!mkt && !mkt.inPlay) {
                    return false;
                }
                let eventIndex = events.findIndex((x) => x.id === mkt.event.id);
                let market = { ...mkt.catalogue, ...mkt.event.marketCondition };
                market.metadata = mkt.metadata;
                market.marketBook =
                    !!market.metadata && !!market.metadata.book
                        ? market.metadata.book
                        : null;
                market.marketId = mkt.catalogue.marketId;
                if (market.provider !== "BETHUBS") {
                    if (
                        !market.marketBook ||
                        market.status === "CLOSED" ||
                        market.marketBook.status === "CLOSED" ||
                        market.marketBook.status === "INACTIVE" ||
                        !market.marketBook.runners ||
                        market.marketBook.runners.length < 2
                    ) {
                        return false;
                    }
                }
                market.marketId = mkt.catalogue.marketId;
                if (eventIndex === -1) {
                    let evt = mkt.event;
                    evt.status = market.status;
                    evt.eventTypeId = mkt.eventType.id;
                    evt.eventType = mkt.eventType.name;
                    evt.competitionId = mkt.competition.id;
                    evt.compititionName = mkt.competition.name;
                    evt.markets = [market];
                    events.push(evt);
                } else {
                    events[eventIndex].markets.push(market);
                }
            });
        events = events.filter((evet, i) => {
            let market = evet.markets.filter((mkt, i) => {
                return mkt.marketType === "MATCH_ODDS";
            });
            if (market.length === 0) {
                market = evet.markets.filter((mkt, i) => {
                    return mkt.marketType === "BM_MATCH_ODDS";
                });
            }
            if (market.length === 0) {
                market = evet.markets;
            }
            return !!market[0].inPlay === true;
        });
        return events.length;
    }

    showToast(msg, type) {
        let self = this;
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false });
            }, 3000);
        });
    }
    logout(redirecttohome = false) {
        let appType = localStorage.getItem("appType");
        let rememberData = localStorage.getItem("rememberData");
        localStorage.clear();
        localStorage.setItem("rememberData", rememberData);
        if (redirecttohome) {
            window.location.href = window.location.origin + "/auth"
        } else {
            this.setState({ accountData: {} });
        }
        sessionStorage.removeItem('demoIdSsData');
        sessionStorage.removeItem('demoExpo');
        sessionStorage.removeItem('demoPnL');
        // if (appType === "mobile") {
        //   window.location.href = window.location.origin + "/apk";
        // } else {
        //   window.location.href = window.location.origin + "/auth";
        // }
    }
    openNav() {
        if (
            document.getElementById("sidebar") !== null &&
            (document.getElementById("sidebar").style.left === "-270px" ||
                document.getElementById("sidebar").style.left === "")
        )
            document.getElementById("sidebar").style.left = "0px";
        else
            document.getElementById("sidebar").style.left =
                document.documentElement.clientWidth > 574 ? "-270px" : "";
    }
    openRightsideNav() {
        if (document.getElementById("rightsidebar") !== null && (document.getElementById("rightsidebar").style.right === "-270px" || document.getElementById("rightsidebar").style.right === "")) {
            document.getElementById("rightsidebar").style.right = "0px";
            document.getElementById("RightMenuoverlay").style.display = "block";
        } else {
            document.getElementById("rightsidebar").style.right = document.documentElement.clientWidth > 574 ? "-270px" : "";
            document.getElementById("RightMenuoverlay").style.display = "none";
        }
    }
    openSearch() {
        document.getElementById("searchfull").style.display = "block";
    }
    closeSearch() {
        document.getElementById("searchfull").style.display = "none";
    }
    openUserMenu(e) {
        if (document.getElementById("account_pop").style.display === "none") {
            if (!this.state.isMaintanance) {
                document.getElementById("multiBalancePop").style.display = "none";
                document.getElementById("multiRGBalancePop").style.display = "none";
            }
            document.getElementById("account_pop").style.display = "block";
        } else {
            document.getElementById("account_pop").style.display = "none";
        }
        return false;
    }
    openBelPopup(e) {
        if (document.getElementById("multiBalancePop").style.display === "none") {
            document.getElementById("account_pop").style.display = "none";
            document.getElementById("multiRGBalancePop").style.display = "none";
            document.getElementById("multiBalancePop").style.display = "block";
        } else {
            document.getElementById("multiBalancePop").style.display = "none";
        }
    }
    async redirect(path) {
        let history = this.props.history;
        await history.push(path);
        this.loadEvtData();
    }
    openRGBelPopup(e) {
        if (document.getElementById("multiRGBalancePop").style.display === "none") {
            document.getElementById("account_pop").style.display = "none";
            document.getElementById("multiBalancePop").style.display = "none";
            document.getElementById("multiRGBalancePop").style.display = "block";
        } else {
            document.getElementById("multiRGBalancePop").style.display = "none";
        }
    }
    // hidePopup() {
    //   this.setState({ showPopup: false });
    // }
    // showPopup() {
    //   this.setState({ showPopup: true });
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }


    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "JoinNow" ? "Login" : "JoinNow");
        this.showPopup(view);
    }


    showStaticMarquee(SclMd) {
        let shw = true;
        if (!!SclMd)
            Object.values(SclMd).forEach((itm) => {
                if (!!itm && itm !== '#') {
                    shw = false;
                }
            });
        return shw;
    }

    onB2BSignupClick() {
        let SclMd = localStorage.getItem("SocialMedia");
        if (!!SclMd && Object.keys(SclMd).length > 0) {
            SclMd = JSON.parse(SclMd);
        }
        // (!!SOCIALMEDIALINKS.whatsapp && SOCIALMEDIALINKS.whatsapp !== '#') || (!!SOCIALMEDIALINKS.telegram && SOCIALMEDIALINKS.telegram !== '#') || (!!SOCIALMEDIALINKS.instagram && SOCIALMEDIALINKS.instagram !== '#')
        if (!!SclMd && !!SclMd?.SOCIALMEDIALINKS?.whatsapp && SclMd?.SOCIALMEDIALINKS?.whatsapp !== '#') {
            let whtsapplinktoclick = SclMd?.SOCIALMEDIALINKS?.whatsapp;
            if (whtsapplinktoclick.includes(',')) {
                let whtsapplinktoclickArr = whtsapplinktoclick.split(',');
                let cntr = this.state.whatsAppLinkclickCounter;
                if (cntr >= (whtsapplinktoclickArr.length - 1)) {
                    cntr = 0;
                } else {
                    cntr = cntr + 1;
                }
                whtsapplinktoclick = whtsapplinktoclickArr[cntr];
                this.setState({ whatsAppLinkclickCounter: cntr });
            }
            // window.location.href = whtsapplinktoclick;
            window.open(whtsapplinktoclick, '_blank');
        } else if (!!SclMd && !!SclMd?.SOCIALMEDIALINKS?.telegram && SclMd?.SOCIALMEDIALINKS?.telegram !== '#') {
            window.location.href = SclMd?.SOCIALMEDIALINKS?.telegram;
        } else if (!!SclMd && !!SclMd?.SOCIALMEDIALINKS?.instagram && SclMd?.SOCIALMEDIALINKS?.instagram !== '#') {
            window.location.href = SclMd?.SOCIALMEDIALINKS?.instagram;
        }
    }

    onLoginBtnClick() {
        if (LoginAndRegisterHaveURL && window.location.pathname !== '/login') {
            // this.props.history.push('/login');
            window.location.href = '/login';
        } else {
            this.showPopup("Login")
        }
    }

    onSignUpBtnClick() {
        if (LoginAndRegisterHaveURL && window.location.pathname !== '/register') {
            // this.props.history.push('/register');
            window.location.href = '/register';
        } else {
            this.showPopup("JoinNow")
        }
    }
    render() {
        let chips = 0;
        let rgchips = 0;
        const accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        let SclMd = localStorage.getItem("SocialMedia");
        if (!!SclMd && Object.keys(SclMd).length > 0) {
            SclMd = JSON.parse(SclMd);
        }
        if (!!accData && Object.keys(accData).length > 0) {
            if (!!this.state.accountData) {
                chips =
                    parseFloat(this.state.accountData.exposure) +
                    parseFloat(this.state.accountData.balance) +
                    parseFloat(this.state.accountData.pnl);
            }
            if (!!this.state.rgAccountData) {
                rgchips =
                    parseFloat(this.state.rgAccountData.exposure) +
                    parseFloat(this.state.rgAccountData.balance) +
                    parseFloat(this.state.rgAccountData.upLineBalance);
            }
        }
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        return (
            <>

                <div className='header-fix'>

                    {!(!!accData && Object.keys(accData).length > 0) &&
                        <div className='header-top flex-center-space'>

                            <div className="header-social-w">
                                {this.showStaticMarquee(SclMd?.SOCIALMEDIALINKS) ?
                                    <div className="marquee-static">
                                        <span className="marquee-icon"><i className="fa fa-bullhorn" aria-hidden="true"></i></span>
                                        {/* <marquee className="marquee-text">Enjoy Unmatched Betting Excitement and Access 500+ Casino and Online Games</marquee> */}
                                        <Marquee className="marquee-text">
                                            Enjoy Unmatched Betting Excitement and Access 500+ Casino and Online Games
                                        </Marquee>
                                    </div>
                                    :
                                    <div className='left flex-center float-left'>
                                        <ul className='socialmediaicon'>
                                            <li><a href={SclMd?.SOCIALMEDIALINKS?.instagram} target='_blank' alt="Instagram" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Instagram"><i className="fa fa-instagram mr-1"></i><span className='m-hide'>Instagram</span></a></li>
                                            <li><a href={SclMd?.SOCIALMEDIALINKS?.facebook} target='_blank' alt="Facebook" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Facebook"><i className="fa fa-facebook mr-1"></i><span className='m-hide'>Facebook</span></a></li>
                                            <li><a href={SclMd?.SOCIALMEDIALINKS?.twitter} target='_blank' alt="Twitter" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Twitter"><i className="fa fa-twitter mr-1"></i><span className='m-hide'>Twitter</span></a></li>
                                            <li><a href={SclMd?.SOCIALMEDIALINKS?.telegram} target='_blank' alt="Telegram Channel" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Telegram" ><i className="fa fa-telegram mr-1"></i><span className='m-hide'>Telegram</span></a></li>
                                            <li><a href={(SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} alt="Whatsapp" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Whatsapp" target="black"><i className="fa fa-whatsapp mr-1"></i><span className='m-hide'>Whatsapp</span></a></li>
                                            {LBLTYPE === 'b2c' && <li onClick={() => { this.props.history.push("/faq") }}>
                                                <a href='#' alt="FAQ" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="FAQ" className={window.location.pathname === "/faq" ? "active" : ""}><i className="fa fa-question-circle-o mr-1"></i><span className='m-hide'>FAQ</span></a>
                                            </li>}
                                            <li><a href='#' alt="Android" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Application" onClick={() => { window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk` }}><i className="fa fa-mobile mr-1"></i><span className='m-hide'>Application</span></a></li>
                                        </ul>
                                    </div>
                                }
                            </div>
                            <div className="date-time-w">
                                <div className='left flex-center float-right'>
                                    <div className='header-time'>
                                        <LiveClock></LiveClock>
                                    </div>
                                    {/* <div className='header-time'>{ this.formatDate() }</div>   */}
                                    {/* <div className='header-time'>
                    {/* date={'1997-12-31T14:15:23+01:00'} *}
                    <Clock ticking={true} format={'DD MMM YYYY, HH:mm:ss'} />
                </div> */}
                                </div>
                            </div>

                        </div>

                    }
                    <header className='loginheader'>
                        {(!!accData && Object.keys(accData).length > 0 && !!profData && profData.role === "DemoClient") && <div className="demodev">Demo Account</div>}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6 col-sm-6 col-md-5 col-lg-4 col-xl-3">
                                    <div className="logo">
                                        <i className="fa fa-bars icon-toggle-right cls-bx-menu baricon" onClick={() => { this.openNav() }}></i>
                                        <a href="/home" className='b2clogolink'><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" alt="logo" className='loginlogo' /></a>
                                    </div>
                                </div>
                                {!!accData && Object.keys(accData).length > 0 ?
                                    <div className="col-6 col-sm-6 col-md-7 col-lg-8 col-xl-9 login-signup-header">
                                        <div className="dep-exp">
                                            {/* <div>
                                                {LBLTYPE === 'b2c' && profData?.role !== "DemoClient" &&
                                                    <button className="withdrawal-btn" target="_blank" onClick={() => { this.setState({ showDepositPopup: true }) }}>
                                                        <span className="line cmenu"><i className="fa fa-money fa-2 darkblack pr-1 cmenu" aria-hidden="true"></i></span>
                                                        <span className="pl-1 cmenu p-8" >Deposit</span>
                                                    </button>
                                                }
                                            </div> */}
                                            {LBLTYPE === 'b2c' && profData?.role !== "DemoClient" &&
                                                <div className="dis-grid dpbtnlg">
                                                    <div className="btn header_Deposit_btn" onClick={() => this.props.history.push('/wallet/deposit')}><span><i className="fa fa-money" aria-hidden="true"></i> Deposit</span></div>
                                                    <div className="btn header_Withdrawal_btn" onClick={() => this.props.history.push('/wallet/withdraw')}><span><i className="fa fa-money" aria-hidden="true"></i> Withdrawal</span></div>
                                                </div>
                                            }
                                            <div className="dis-grid">
                                                <i className="d-none" id="btnHdnRecalculateDemoExpo" onClick={() => this.refreshDemoBalExpo()}></i>
                                                <button id="btnExpoRightMenu" className="exposure-btn ml-1" onClick={() => { this.openRightsideNav() }}>
                                                    <span className="line coin cmenu"><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/coin.svg"} className="pr-1 cmenu" alt="" /></span>
                                                    {/* <span className="line cmenu"><i className="fa fa-user darkblack pr-1 cmenu" aria-hidden="true"></i></span> */}
                                                    <span className="pl-1 cmenu p2">{!!this.state.accountData && !!this.state.accountData && chips > 0 ? chips.toFixed(this.state.clientWidth < 768 ? 0 : 2) : "0.00"}</span>
                                                </button>

                                                <button id="btnExpoRightMenu" className="exposure-btn ml-1" onClick={() => { this.openRightsideNav() }}>
                                                    <span className="line cmenu ex-f">Exp :</span>
                                                    <span className="pl-1 cmenu p2">
                                                        {!!this.state.accountData && !!this.state.accountData.exposure ? parseFloat(this.state.accountData.exposure).toFixed(2) : "0.00"}
                                                        {/* {!!this.state.accountData && !!this.state.accountData && chips > 0 ? chips.toFixed(this.state.clientWidth < 768 ? 0 : 2) : "0.00"} */}
                                                    </span>
                                                </button>
                                            </div>

                                            {profData.role != "DemoClient" && 
                                                <div className="notification-box exposure-btn dpbtnlg" onClick={() => { this.props.history.push("/notifications") }}>
                                                    <div className='Notification'>
                                                        <i className="ml-2 fa fa-bell text-white" />
                                                        {(
                                                            <span className="badge">{this.state.notificationCount}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                            <ul className="account-wrap">

                                            </ul>
                                        </div>
                                    </div>
                                    :
                                    <div className="col-6 col-sm-6 col-md-7 col-lg-8 col-xl-9 login-signup-header">
                                        <div className="">
                                            <ul className="login-wrap ">
                                                <li>
                                                    <button id='btnLoginb2cLogin' className=" b2clogin" tabIndex={3} onClick={(e) => { this.onLoginBtnClick() }}><i className="fa fa-user mr1" aria-hidden="true"></i> Log in </button>
                                                </li>
                                                {LBLTYPE === 'b2c' &&
                                                    <li>
                                                        <button className="b2csignup" tabIndex={3} onClick={() => { this.onSignUpBtnClick() }} style={{ cursor: "pointer" }}>SIGN up </button>
                                                    </li>
                                                }
                                                {LBLTYPE === 'b2b' && ShowB2BSignUpButton && !!SclMd && ((!!SclMd?.SOCIALMEDIALINKS?.whatsapp && SclMd?.SOCIALMEDIALINKS?.whatsapp !== '#') || (!!SclMd?.SOCIALMEDIALINKS?.telegram && SclMd?.SOCIALMEDIALINKS?.telegram !== '#') || (!!SclMd?.SOCIALMEDIALINKS?.instagram && SclMd?.SOCIALMEDIALINKS?.instagram !== '#')) &&
                                                    <li>
                                                        <button className="b2csignup" tabIndex={3} onClick={() => { this.onB2BSignupClick() }} style={{ cursor: "pointer" }}>SIGN up </button>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </header>
                    {/* RIGHT SIDE MENU OPEN */}
                    {(!!accData && Object.keys(accData).length > 0) &&
                        <>
                            <div id="rightsidebar" className="right-sidenav">
                                <a className="closebtn" onClick={() => { this.openRightsideNav() }}>&times;</a>
                                <span className='profilename'><i className="fa fa-user darkblue pr-2 cmenu" aria-hidden="true"></i>{!!profData ? (profData.role !== "DemoClient" ? this.state.uid : 'Demo') : ""} - ({!!this.state.accountData && !!this.state.accountData && chips > 0 ? chips.toFixed(this.state.clientWidth < 768 ? 0 : 2) : "0.00"})</span>
                                {/* <span className="pl-1 cmenu p2">{!!this.state.accountData && !!this.state.accountData && chips > 0 ? chips.toFixed(this.state.clientWidth < 768 ? 0 : 2) : "0.00"}</span> */}
                                <div className='rightside-exposure'>
                                    <div className="right-wallet-detail-group cmenu">
                                        <dl className="wallet-detail-content mb-1 cmenu" onClick={() => { if (profData.role !== "DemoClient") { this.showPopup() } }}>
                                            <dt className={"cmenu"}>Exposure</dt>
                                            <dd className="wallet-balance-num cmenu">
                                                <span id="mainBalance" className={"cmenu"}>
                                                    <Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.accountData && !!this.state.accountData.exposure ? parseFloat(this.state.accountData.exposure).toFixed(2) : "0.00"} />
                                                </span>
                                            </dd>

                                        </dl>
                                    </div>
                                    <div className="right-wallet-detail-group cmenu">
                                        <dl className="wallet-detail-content mb-1 cmenu">
                                            <dt className={"cmenu"}>P&amp;L</dt>
                                            <dd className="wallet-balance-num cmenu">
                                                <span id="mainBalance" className={"cmenu"}>
                                                    <Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.accountData && !!this.state.accountData.pnl ? this.state.accountData.pnl : "0"} />
                                                </span>
                                            </dd>

                                        </dl>
                                    </div>
                                </div>
                                {!!profData && profData.role !== "DemoClient" && ((showClubGames.onlyInOfficeChnl
                                    ? this.state.isOfficeChannel
                                    : false) ||
                                    showClubGames.show) &&
                                    <div className='rightside-exposure'>
                                        <div className="right-wallet-detail-group cmenu cg-btn-new">
                                            <dl className="wallet-detail-content mb-1 cmenu">
                                                <dt className={"cmenu cg-btn-f"}>CG Exposure</dt>
                                                <dd className="wallet-balance-num cmenu pb-0 mb-0">
                                                    <span id="mainBalance" className={"cmenu"}>
                                                        <Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.rgAccountData && !!this.state.rgAccountData.exposure ? parseFloat(this.state.rgAccountData.exposure).toFixed(2) : "0.00"} />
                                                    </span>
                                                </dd>

                                            </dl>
                                        </div>
                                        <div className="right-wallet-detail-group cmenu cg-btn-new">
                                            <dl className="wallet-detail-content mb-1 cmenu">
                                                <dt className={"cmenu cg-btn-f"}>CG P&amp;L</dt>
                                                <dd className="wallet-balance-num cmenu pb-0 mb-0">
                                                    <span id="mainBalance" className={"cmenu"}>
                                                        <Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.rgAccountData && !!this.state.rgAccountData.pnl ? this.state.rgAccountData.pnl : "0"} />
                                                    </span>
                                                </dd>

                                            </dl>
                                        </div>
                                    </div>
                                }
                                <ul id="account_pop" className={"cmenu"} style={{ "display": "block", zIndex: "999" }}>
                                    {(!!profData ? profData.role !== "DemoClient" : true) && !this.props.isMaintanance && LBLTYPE === 'b2c' &&
                                        <li onClick={() => { this.redirect("/profile") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/change-password.svg"} className="ball-images-tab" /> Profile</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && <li onClick={() => { this.redirect("/accountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" />Account Statement</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && ((showClubGames.onlyInOfficeChnl
                                        ? this.state.isOfficeChannel
                                        : false) ||
                                        showClubGames.show) && <li onClick={() => { this.redirect("/cgaccountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" /> CG Account Statement</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && LBLTYPE === 'b2c' && <li onClick={() => { this.redirect("/transactionsReport") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/transactions-report.svg"} className="ball-images-tab" /> Transactions Report</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && <li onClick={() => { this.redirect("/profitloss") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/profit-loss-report.svg"} className="ball-images-tab" /> Profit Loss Report</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && <li onClick={() => { this.redirect("/bethistroy") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/bet-history.svg"} className="ball-images-tab" /> Bet Histroy</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && ((showClubGames.onlyInOfficeChnl
                                        ? this.state.isOfficeChannel
                                        : false) ||
                                        showClubGames.show) && <li onClick={() => { this.redirect("/cgbethistroy") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/bet-history.svg"} className="ball-images-tab" />CG Bet Histroy</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && <li onClick={() => { this.redirect("/unsettledbet") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/unsettle-bet.svg"} className="ball-images-tab" /> Unsettled Bet</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && ((showClubGames.onlyInOfficeChnl
                                        ? this.state.isOfficeChannel
                                        : false) ||
                                        showClubGames.show) && <li onClick={() => { this.redirect("/cgunsettledbet") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/unsettle-bet.svg"} className="ball-images-tab" />CG Unsettled Bet</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && !this.props.isMaintanance && <li onClick={() => { this.redirect("/userprofile") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/set-button-value.svg"} className="ball-images-tab" /> Set Stake</a></li>}
                                    <li onClick={() => { this.redirect("/rules") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rules.svg"} className="ball-images-tab" /> Rules</a></li>
                                    {(!!profData ? profData.role !== "DemoClient" : true) && !this.props.isMaintanance && <li onClick={() => { this.redirect("/changepassword") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/change-password.svg"} className="ball-images-tab" /> Change Password</a></li>}
                                    {(!!profData ? profData.role !== "DemoClient" : true) && <li onClick={() => { this.redirect("/result") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/result.svg"} className="ball-images-tab" /> Results</a></li>}
                                    <li className='logout' onClick={() => { authUtil.logout(true) }}><a id='logout'><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/log-out.svg"} className="ball-images-tab" /> Logout</a></li>
                                </ul>
                            </div>
                            <div className="overlay" id="RightMenuoverlay" onClick={() => { this.openRightsideNav() }}></div>
                        </>
                    }
                    {/* RIGHT SIDE MENU CLOSE */}
                    <section className='b2cmenu inner'>
                        <nav>
                            <div className="navbar cls-navbar">
                                <i className='bx bx-menu cls-bx-menu'></i>
                                <div className="nav-links cls-nav-links">
                                    <div className="sidebar-logo">
                                        <i className='bx bx-x cls-bx-x fa fa-times-circle' ></i>
                                    </div>
                                    <ul className="links afterlogin" >
                                        {!this.state.isMaintanance ? <>
                                            <li><a onClick={() => { this.redirect('/home') }} className={window.location.pathname === "/home" ? "active" : null}>Home</a></li>
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/inplay') }}><a className={window.location.pathname === "/inplay" ? "active" : null}>In-Play</a></li>}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/multimarket') }}><a className={window.location.pathname === "/multimarket" ? "active" : null}>Multi Markets</a></li>} as asked by ricky */}
                                            {/* {this.state.accessControl.casino && this.state.showevolution && 
                                } */}
                                            {showSportsBookLink.show && <li onClick={() => { this.redirect('/sportbook') }}><a className={window.location.pathname === "/sportbook" ? "active sportbook-hl" : "sportbook-hl"}> SportsBook</a></li>}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/fifacup2022') }}><a className={window.location.pathname === "/fifacup2022" ? "select" : ""}>WCT20 Winner</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ipl') }}><a className={window.location.pathname === "/ipl" ? "select awesome" : "awesome"}>IPL 2025</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wplwinner') }}><a className={window.location.pathname === "/wplwinner" ? "select awesome" : "awesome"}>WPL 2025</a></li>} */}
                                            {(!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && this.state.accessControl.sports) && <li onClick={() => { this.redirect('/game/500') }}><a className={window.location.pathname === "/game/500" ? "active awesome" : "awesome"}><span id="tagLive" className="tag-live"><strong></strong>{this.state.electInplay}</span>{ElectionDisplayLabel}</a></li>}
                                            {(!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && this.state.accessControl.sports) && <li onClick={() => { this.redirect('/game/400') }}><a className={window.location.pathname === "/game/400" ? "active awesome" : "awesome"}><span id="tagLive" className="tag-live"><strong></strong>{this.state.kbdInplay}</span>Kabaddi</a></li>}
                                            {
                                                this.state.accessControl.sports && !!winnereventdic && !!winnereventdic["eventDicByName"] && Object.keys(winnereventdic["eventDicByName"]).length > 0 && Object.keys(winnereventdic["eventDicByName"]).map((itm, i) => {
                                                    let itmm = winnereventdic["eventDicByName"][itm];
                                                    if (!itmm.show) {
                                                        return false;
                                                    }
                                                    if (!itmm.showInMenu) {
                                                        return false;
                                                    }
                                                    return (
                                                        <li key={`0_${i}_${itm}`} onClick={() => { this.redirect(itmm["url"]) }}><a className={window.location.pathname === itmm["url"] ? "select awesome" : "awesome"}>{itmm["displayName"]}</a></li>
                                                    )
                                                })
                                            }
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wbbl2025') }}><a className={window.location.pathname === "/wbbl2025" ? "select awesome" : "awesome"}>WBBL 2025</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wt20') }}><a className={window.location.pathname === "/wt20" ? "select awesome" : "awesome"}>WC Winner 2024</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ivl') }}><a className={window.location.pathname === "/ivl" ? "select awesome" : "awesome"}>IVL T20</a></li>} */}
                                            {ShowSportsBattle && this.state.accessControl.sports && <li onClick={() => { this.redirect('/sportsbattle') }}><a className={window.location.pathname === "/sportsbattle" || window.location.pathname.includes("/sportsbattleevent") ? "active" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.cktInplay}</span>Sports Battle</a></li>}
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/4') }}><a className={window.location.pathname === "/game/4" || window.location.pathname.includes("/event/4/") ? "active" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.cktInplay}</span>   Cricket</a></li>}
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/1') }}><a className={window.location.pathname === "/game/1" || window.location.pathname.includes("/event/1/") ? "active" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.socInplay}</span>Soccer</a></li>}
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/2') }}><a className={window.location.pathname === "/game/2" || window.location.pathname.includes("/event/2/") ? "active" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.tenInplay}</span>Tennis</a></li>}
                                            {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && (!!accData && Object.keys(accData).length > 0) && this.state.accessControl.casino && <li onClick={() => { this.redirect('/clubgames') }}><a className={window.location.pathname === "/clubgames" ? "active awesome" : "awesome"}> Club Games</a></li>}
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/7') }}><a className={window.location.pathname === "/game/7" || window.location.pathname.includes("/event/7/") ? "active " : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.horsInplay}</span>Horse</a></li>}
                                            {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/4339') }}><a className={window.location.pathname === "/game/4339" || window.location.pathname.includes("/event/4339/") ? "active" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.houndInplay}</span>Greyhound</a></li>}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ipl') }}><a className={window.location.pathname === "/ipl" ? "active sportbook-hl" : "sportbook-hl"}>IPL Winner 2023</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/bigbash2022') }}><a className={window.location.pathname === "/bigbash2022" ? "select sportbook-hl" : "sportbook-hl"}>Big Bash 2022</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/pslwinner') }}><a className={window.location.pathname === "/pslwinner" ? "select sportbook-hl" : "sportbook-hl"}>PSL Winner 2023</a></li>}
                      {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wplwinner') }}><a className={window.location.pathname === "/wplwinner" ? "select sportbook-hl" : "sportbook-hl"}>WPL Winner 2023</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/fifacup2022') }}><a className={window.location.pathname === "/fifacup2022" ? "select sportbook-hl" : "sportbook-hl"}>FIFA CUP 2022</a></li>} */}
                                            {/* {this.state.accessControl.casino && <li onClick={() => { this.redirect('/clubgames') }}><a className={window.location.pathname === "/clubgames" ? "active" : ""}> Club Games</a></li>} */}
                                            {/* {this.state.accessControl.casino && <li onClick={() => { this.redirect('/indianpoker') }}><a className={window.location.pathname === "/indianpoker" ? "active "  : ""}> Indian Poker</a></li>}
                                {/* {this.state.accessControl.casino && <li><a href="/indianpoker2" className={window.location.pathname === "/indianpoker2" ? "active" : null}> Indian Poker 2</a></li>} *}
                                {this.state.accessControl.casino && this.state.showevolution && <li onClick={() => { this.redirect('/evolution') }}><a className={window.location.pathname === "/evolve" ? "active "  : ""}> Evolution</a></li>}
                                {this.state.accessControl.casino && <li onClick={() => { this.redirect('/casino') }}><a className={window.location.pathname === "/casino" ? "active " : ""}>Casino</a></li>}
                                {/* {this.state.accessControl.casino && <li onClick={() => { this.redirect('/casino2') }}><a className={window.location.pathname === "/casino2" ? "active awesomemobile" : "awesomemobile"}>Casino 2</a></li>} *}
                                {this.state.accessControl.casino && <li onClick={() => { this.redirect('/virtualsports') }}><a className={window.location.pathname === "/virtualsports" ? "active " : ""}>V-Sports</a></li>} */}
                                            {
                                                this.state.accessControl.casino && Object.values(casinoList).map((itm, i) => {
                                                    return (itm.show &&
                                                        <>
                                                            <li key={`1_${itm.provider}_${i}`} onClick={() => { this.redirect(itm.url) }}><a className={window.location.pathname === itm.url ? "select " : ""}>
                                                                {
                                                                    itm.iconontop &&
                                                                    <span id="tagLive" className="tag-live1"><img className="ball-images-tab1-aviator new-scrollmenu" src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`} alt="" /></span>
                                                                }
                                                                {itm.displayName}</a>
                                                            </li>
                                                        </>
                                                    );
                                                })
                                            }
                                            {showEsportLink.show && <li onClick={() => { this.redirect('/esport') }}><a className={window.location.pathname === "/esport" ? "active sportbook-hl" : "sportbook-hl"}> E-Sport</a></li>}
                                            {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/fifacup2022') }}><a className={window.location.pathname === "/fifacup2022" ? "active awesomemobile " : "awesomemobile"}>WorldCup Winner</a></li>} */}
                                            {/* {this.state.accessControl.sports && <li><a href="/psl" className={window.location.pathname === "/psl" ? "active awesome" : "awesome"}>PSL Winner</a></li>} */}
                                            {showBinary && this.state.accessControl.binary && <li onClick={() => { this.redirect('/binary') }}><a className={window.location.pathname === "/binary" ? "active " : ""}>Binary</a></li>}
                                            {/* {this.state.accessControl.casino && <li><a href="/slotgames" className={window.location.pathname === "/slotgames" ? "active" : null} >Slot Games</a></li>} */}
                                        </> : <>
                                            <li onClick={() => { this.redirect('/maintanance') }}><a className={window.location.pathname === "/maintanance" ? "active" : null}>Home</a></li>
                                            <li onClick={() => { this.redirect('/3droulette') }}><a className={window.location.pathname === "/games/3droulette" ? "active" : null}>3D Roulette</a></li>
                                        </>}
                                    </ul>
                                    <button className='mobileapp'><i className='fa fa-mobile mr-2'></i>Mobile App</button>

                                    <div className='header-mobile__content'>
                                        <ul className='mobilemenu_ul'>
                                            <li><a href='#innersection' className={this.props.selectedSection === "" ? 'active' : ''} onClick={() => this.toggleSelectedSection('')}>Home</a></li>
                                            <li><a href='#innersection' className={this.props.selectedSection === "aboutus" ? 'active' : ''} onClick={() => this.toggleSelectedSection('aboutus')}>About Us</a></li>
                                            <li><a href='#innersection' className={this.props.selectedSection === "termandconditions" ? 'active' : ''} onClick={() => this.toggleSelectedSection('termandconditions')}>Terms and Conditions</a></li>
                                            <li><a href='#innersection' className={this.props.selectedSection === "privacypolicy" ? 'active' : ''} onClick={() => this.toggleSelectedSection('privacypolicy')}>Privacy Policy</a></li>
                                            <li><a href='#innersection' className={this.props.selectedSection === "bettingrules" ? 'active' : ''} onClick={() => this.toggleSelectedSection('bettingrules')}>Betting Rules</a></li>
                                            <li><a href='#innersection' className={this.props.selectedSection === "depositsandwithdrawals" ? 'active' : ''} onClick={() => this.toggleSelectedSection('depositsandwithdrawals')}>Deposits and Withdrawals Rules</a></li>
                                        </ul>
                                    </div>
                                    <div className='header_mobile_socialicon'>
                                        <ul className='mobilemenuicon_ul'>
                                            <li><a href='https://www.instagram.com/rdreamfair_official/' target='_blank' alt="Instagram" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Instagram"><i className="fa fa-instagram mr-1"></i></a></li>
                                            <li><a href='https://www.facebook.com/rdreamfair' target='_blank' alt="Facebook" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Facebook"><i className="fa fa-facebook mr-1"></i></a></li>
                                            <li><a href='https://twitter.com/rDreamFair' target='_blank' alt="Twitter" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Twitter"><i className="fa fa-twitter mr-1"></i></a></li>
                                            <li><a href='https://t.me/rDreamFair_official' target='_blank' alt="Telegram Channel" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Telegram" ><i className="fa fa-telegram mr-1"></i></a></li>
                                            <li><a href='#' alt="Make a call" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Make a call"><i className="fa fa-phone mr-1"></i></a></li>

                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </nav>
                    </section>
                </div>
                <div className="top d-none">
                    {/* {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV</span>} */}
                    <div className="header full-wrap">
                        <div className="d-inline">
                            <i className="fa fa-bars icon-toggle-right mobile-menu" onClick={() => { this.openNav() }}></i>
                            <a className="logo" onClick={() => { !this.state.isMaintanance ? this.redirect('/home') : this.redirect('/maintanance') }}><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" className="mainlogo" /></a>
                        </div>
                        {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                        <ul className="account-wrap">

                            {!this.state.isMaintanance &&
                                <li className={"mb3 cmenu"}>
                                    <a style={{ cursor: "pointer" }} onClick={(e) => { this.openBelPopup(e) }} className="hed-btn text-white cmenu">
                                        <span className="line coin cmenu"><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/coin.svg"} className="pr-1 cmenu" /></span>
                                        <span className="pl-1 cmenu p2">{!!this.state.accountData && !!this.state.accountData && chips > 0 ? chips.toFixed(2) : "0.00"}</span>
                                        <i className="fa fa-caret-down pl-2 cmenu rigarrow" aria-hidden="true"></i>
                                    </a>
                                    <div className="wallet-detail cmenu" id="multiBalancePop" style={{ display: "none" }}>
                                        <div className="wallet-detail-group cmenu">
                                            <dl className="wallet-detail-content mb-1 cmenu" onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>
                                                <dt className={"cmenu"}>Exposure</dt>
                                                <dd className="wallet-balance-num cmenu"><span id="mainBalance" className={"cmenu"}><Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.accountData && !!this.state.accountData.exposure ? parseFloat(this.state.accountData.exposure).toFixed(2) : "0.00"} /></span></dd>
                                            </dl>
                                        </div>
                                        <div className="wallet-detail-group cmenu">
                                            <dl className="wallet-detail-content mb-1 cmenu">
                                                <dt className={"cmenu"}>P&amp;L</dt>
                                                <dd className="wallet-balance-num cmenu"><span id="mainBalance" className={"cmenu"}><Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.accountData && !!this.state.accountData.pnl ? this.state.accountData.pnl : "0"} /></span></dd>
                                            </dl>
                                        </div>
                                        <div className="btn-box cmenu">
                                            <button onClick={() => { this.openBelPopup() }} className="btn">Close</button>
                                        </div>
                                    </div>
                                </li>
                            }
                            {!this.state.isMaintanance &&
                                <li className={"cmenu"}>
                                    {/* <a style={{ cursor: "pointer" }} onClick={(e) => { this.openRGBelPopup(e) }} className="hed-btn text-white cmenu">
                                        <span className="line coin cmenu cgtext">RC</span>
                                        <span className="pl-1 cmenu  p-6">{!!this.state.rgAccountData && rgchips > 0 ? rgchips.toFixed(2) : "0.00"}</span>
                                        <i className="fa fa-caret-down pl-2 cmenu rigarrow" aria-hidden="true"></i>
                                    </a> */}
                                    <div className="wallet-detail cmenu" id="multiRGBalancePop" style={{ display: "none" }}>
                                        <div className="wallet-detail-group cmenu">
                                            <dl className="wallet-detail-content mb-1 cmenu">
                                                <dt className={"cmenu"}>CG Exposure</dt>
                                                <dd className="wallet-balance-num cmenu"><span id="mainBalance" className={"cmenu"}><Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.rgAccountData && !!this.state.rgAccountData.exposure ? this.state.rgAccountData.exposure : "0"} /></span></dd>
                                            </dl>
                                        </div>
                                        <div className="wallet-detail-group cmenu">
                                            <dl className="wallet-detail-content mb-1 cmenu">
                                                <dt className={"cmenu"}>CG P&amp;L</dt>
                                                <dd className="wallet-balance-num cmenu"><span id="mainBalance" className={"cmenu"}><Currency classPropName={"cmenu"} showColor={true} amount={!!this.state.rgAccountData && !!this.state.rgAccountData.upLineBalance ? this.state.rgAccountData.upLineBalance : "0"} /></span></dd>
                                            </dl>
                                        </div>
                                        <div className="btn-box cmenu">
                                            <button onClick={(e) => { this.openRGBelPopup(e) }} className="btn">Close</button>
                                        </div>
                                    </div>
                                </li>
                            }
                            <li className="cmenu mb3">
                                <a style={{ cursor: "pointer" }} target="_blank" onClick={(e) => { e.stopPropagation(); this.openUserMenu(e) }} className="hed-btn cmenu" id="accountPopup">
                                    <span className="line cmenu"><i className="fa fa-user darkblue pr-1 cmenu" aria-hidden="true"></i></span>
                                    <span className="pl-1 cmenu p-8" style={{ color: "white" }}>My Account</span>
                                    <i style={{ color: "white" }} className="fa fa-caret-down pl-2 cmenu rigarrow" aria-hidden="true"></i>
                                </a>
                                <ul id="account_pop" className={"cmenu"} style={{ "display": "none", zIndex: "999" }}>
                                    <li className={"cmenu"}>
                                        <h4 className={"cmenu"}>
                                            {this.state.uid}
                                            {/* <span className={"cmenu gmt"} title="Time Zone">GMT+5:30</span> */}
                                        </h4>
                                    </li>
                                    {/* {!this.props.isMaintanance && 
                                    <li onClick={() => { this.redirect("/profile") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/change-password.svg"} className="ball-images-tab" /> Account Details </a></li>
                                    } */}
                                    {!this.props.isMaintanance && LBLTYPE === 'b2c' && <li onClick={() => { this.redirect("/profile") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/change-password.svg"} className="ball-images-tab" /> Profile</a></li>}
                                    {/* {!this.props.isMaintanance && <li onClick={() => { this.redirect("/withdraw")}}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/cash-withdrawal.svg"} className="ball-images-tab" /> Withdraw</a></li>} */}
                                    {/* <li onClick={() => { this.redirect("/accountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" /> Account Statement</a></li> */}
                                    <li onClick={() => { this.redirect("/accountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" /> Account Statement</a></li>
                                    {/* <li onClick={() => { this.redirect("/cgaccountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" /> CG Account Statement</a></li> */}
                                    {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && <li onClick={() => { this.redirect("/cgaccountstatement") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/Account-Statement.svg"} className="ball-images-tab" /> CG Account Statement</a></li>}
                                    {LBLTYPE === 'b2c' && <li onClick={() => { this.redirect("/transactionsReport") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/transactions-report.svg"} className="ball-images-tab" /> Transactions Report</a></li>}
                                    <li onClick={() => { this.redirect("/profitloss") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/profit-loss-report.svg"} className="ball-images-tab" /> Profit Loss Report</a></li>
                                    <li onClick={() => { this.redirect("/bethistroy") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/bet-history.svg"} className="ball-images-tab" /> Bet Histroy</a></li>
                                    {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && <li onClick={() => { this.redirect("/cgbethistroy") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/bet-history.svg"} className="ball-images-tab" /> CG Bet Histroy</a></li>}
                                    {/* <li onClick={() => { this.redirect("/cgbethistroy") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/bet-history.svg"} className="ball-images-tab" />CG Bet Histroy</a></li> */}
                                    <li onClick={() => { this.redirect("/unsettledbet") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/unsettle-bet.svg"} className="ball-images-tab" /> Unsettled Bet</a></li>
                                    {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && <li onClick={() => { this.redirect("/cgunsettledbet") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/unsettle-bet.svg"} className="ball-images-tab" /> CG Unsettled Bet</a></li>}
                                    {/* <li onClick={() => { this.redirect("/cgunsettledbet") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/unsettle-bet.svg"} className="ball-images-tab" />CG Unsettled Bet</a></li> */}
                                    {!this.props.isMaintanance && <li onClick={() => { this.redirect("/userprofile") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/set-button-value.svg"} className="ball-images-tab" /> Set Stake</a></li>}
                                    <li onClick={() => { this.redirect("/rules") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rules.svg"} className="ball-images-tab" /> Rules</a></li>
                                    {(!this.props.isMaintanance && showChangePasswordBtn) && <li onClick={() => { this.redirect("/changepassword") }}><a><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/change-password.svg"} className="ball-images-tab" /> Change Password</a></li>}
                                    {showLogoutBtn && <li className='logout' onClick={() => { authUtil.logout(true) }}><a id='logout'><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/log-out.svg"} className="ball-images-tab" /> Logout</a></li>}
                                </ul>
                            </li>
                            <li className=" cmenu">
                                <a id="btnPayInOut" style={{ cursor: "pointer" }} target="_blank" className="hed-btn cmenu" onClick={() => { this.setState({ showDepositPopup: true }) }}>
                                    <span className="line cmenu"><i className="fa fa-money fa-2 darkblue pr-1 cmenu" aria-hidden="true"></i></span>
                                    <span className="pl-1 cmenu p-8" style={{ color: "white" }}>Pay In / Out</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="menu-wrap mobile-menu-hide">
                        <div className="full-wrap">
                            <ul className="menu">
                                {!this.state.isMaintanance ? <>
                                    <li><a onClick={() => { this.redirect('/home') }} className={window.location.pathname === "/home" ? "select" : null}>Home</a></li>
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/inplay') }}><a className={window.location.pathname === "/inplay" ? "select" : null}>In-Play</a></li>}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/multimarket') }}><a className={window.location.pathname === "/multimarket" ? "select" : null}>Multi Markets</a></li>} as asked by ricky*/}
                                    {/* {this.state.accessControl.casino && this.state.showevolution && 
                                    } */}
                                    {showSportsBookLink.show && <li onClick={() => { this.redirect('/sportbook') }}><a className={window.location.pathname === "/sportbook" ? "select sportbook-hl" : "sportbook-hl"}> SportsBook</a></li>}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ipl') }}><a className={window.location.pathname === "/ipl" ? "select awesome" : "awesome"}>IPL 2025</a></li>} */}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wplwinner') }}><a className={window.location.pathname === "/wplwinner" ? "select awesome" : "awesome"}>WPL 2025</a></li>} */}
                                    {(!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && this.state.accessControl.sports) && <li onClick={() => { this.redirect('/game/500') }}><a className={window.location.pathname === "/game/500" ? "active awesome" : "awesome"}><span id="tagLive" className="tag-live"><strong></strong>{this.state.electInplay}</span>{ElectionDisplayLabel}</a></li>}
                                    {(!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && this.state.accessControl.sports) && <li onClick={() => { this.redirect('/game/400') }}><a className={window.location.pathname === "/game/400" ? "select awesome" : "awesome"}><span id="tagLive" className="tag-live"><strong></strong>{this.state.kbdInplay}</span>Kabaddi</a></li>}
                                    {
                                        this.state.accessControl.sports && !!winnereventdic && !!winnereventdic["eventDicByName"] && Object.keys(winnereventdic["eventDicByName"]).length > 0 && Object.keys(winnereventdic["eventDicByName"]).map((itm, i) => {
                                            let itmm = winnereventdic["eventDicByName"][itm];
                                            if (!itmm.show) {
                                                return false;
                                            }
                                            if (!itmm.showInMenu) {
                                                return false;
                                            }
                                            return (
                                                <li key={`1_${i}_${itm}`} onClick={() => { this.redirect(itmm["url"]) }}><a className={window.location.pathname === itmm["url"] ? "select awesome" : "awesome"}>{itmm["displayName"]}</a></li>
                                            )
                                        })
                                    }
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wbbl2025') }}><a className={window.location.pathname === "/wbbl2025" ? "select awesome" : "awesome"}>WBBL 2025</a></li>} */}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wt20') }}><a className={window.location.pathname === "/wt20" ? "select awesome" : "awesome"}>WC Winner 2024</a></li>} */}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ivl') }}><a className={window.location.pathname === "/ivl" ? "select awesome" : "awesome"}>IVL T20</a></li>} */}
                                    {ShowSportsBattle && this.state.accessControl.sports && <li onClick={() => { this.redirect('/sportsbattle') }}><a className={window.location.pathname === "/sportsbattle" || window.location.pathname.includes("/sportsbattleevent") ? "select" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.cktInplay}</span>Sports Battle</a></li>}
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/4') }}><a className={window.location.pathname === "/game/4" || window.location.pathname.includes("/event/4/") ? "select" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.cktInplay}</span>   Cricket</a></li>}
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/1') }}><a className={window.location.pathname === "/game/1" || window.location.pathname.includes("/event/1/") ? "select" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.socInplay}</span>Soccer</a></li>}
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/2') }}><a className={window.location.pathname === "/game/2" || window.location.pathname.includes("/event/2/") ? "select" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.tenInplay}</span>Tennis</a></li>}
                                    {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && (!!accData && Object.keys(accData).length > 0) && this.state.accessControl.casino && <li onClick={() => { this.redirect('/clubgames') }}><a className={window.location.pathname === "/clubgames" ? "select awesome" : "awesome"}> Club Games</a></li>}
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/7') }}><a className={window.location.pathname === "/game/7" || window.location.pathname.includes("/event/7/") ? "select " : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.horsInplay}</span>Horse</a></li>}
                                    {this.state.accessControl.sports && <li onClick={() => { this.redirect('/game/4339') }}><a className={window.location.pathname === "/game/4339" || window.location.pathname.includes("/event/4339/") ? "select" : null}><span id="tagLive" className="tag-live"><strong></strong>{this.state.houndInplay}</span>Greyhound</a></li>}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/ipl') }}><a className={window.location.pathname === "/ipl" ? "select sportbook-hl" : "sportbook-hl"}>IPL Winner 2023</a></li>} */}
                                    {/* {this.state.accessControl.sports && <li onClick={() => { this.redirect('/pslwinner') }}><a className={window.location.pathname === "/pslwinner" ? "select sportbook-hl" : "sportbook-hl"}>PSL Winner 2023</a></li>}
                  {this.state.accessControl.sports && <li onClick={() => { this.redirect('/wplwinner') }}><a className={window.location.pathname === "/wplwinner" ? "select sportbook-hl" : "sportbook-hl"}>WPL Winner 2023</a></li>} */}


                                    {
                                        this.state.accessControl.casino && Object.values(casinoList).map((itm, i) => {
                                            return (itm.show &&
                                                <>
                                                    <li key={`1_${itm.provider}_${i}`} onClick={() => { this.redirect(itm.url) }}><a className={window.location.pathname === itm.url ? "select " : ""}>
                                                        {
                                                            itm.iconontop &&
                                                            <span id="tagLive" className="tag-live1"><img className="ball-images-tab1-aviator new-scrollmenu" src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`} alt="" /></span>
                                                        }
                                                        {itm.displayName}</a>
                                                    </li>
                                                </>
                                            );
                                        })
                                    }

                                    {showEsportLink.show && <li onClick={() => { this.redirect('/esport') }}><a className={window.location.pathname === "/esport" ? "select sportbook-hl" : "sportbook-hl"}> E-Sports</a></li>}
                                    {(showBinary && this.state.accessControl.binary) && <li onClick={() => { this.redirect('/binary') }}><a className={window.location.pathname === "/binary" ? "select " : ""}>Binary</a></li>}
                                </> : <>
                                    <li onClick={() => { this.redirect('/maintanance') }}><a className={window.location.pathname === "/maintanance" ? "select" : null}>Home</a></li>
                                    <li onClick={() => { this.redirect('/3droulette') }}><a className={window.location.pathname === "/games/3droulette" ? "select" : null}>3D Roulette</a></li>
                                </>}
                            </ul>
                        </div>
                    </div>
                </div>
                {this.state.showPopup && <UnsetteledBetsPopup hidePopup={() => { this.setState({ showPopup: false }) }} />}
                {this.state.showDepositPopup &&
                    <>
                        {/* {OPERATOR_ID === 'RDR'? */}
                        {OPERATOR_ID === 'HEB' ?

                            <Depositpopuphebebook notify={this.props.notify} hidePopup={() => { this.setState({ showDepositPopup: false }) }} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} />
                            :
                            <Depositpopup notify={this.props.notify} hidePopup={() => { this.setState({ showDepositPopup: false }) }} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} history={this.props.history} />
                        }
                    </>}

                {this.state.showJoinNowPopup && <Joinnowpopup hidePopup={() => { this.hidePopup("JoinNow") }} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name) => { this.toggleSelectedSection(name) }} affCode={this.props.affCode} />}
                {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) => this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} pwdch={this.state.pwdch} />}

                {window.location.pathname !== "/sportbook" && window.location.pathname !== "/esport" && <Footer marquee={this.state.marquee} history={this.props.history} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify} />}

                <div className={`scrollmenu scrollmenuheader ${(!!accData && Object.keys(accData).length > 0) ? '' : 'scrollmenuheader-login'}`}>
                    {!this.state.isMaintanance ? <>
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/inplay') }} className={window.location.pathname === "/inplay" ? "active" : null}>
                                <span className='sports-icon inplaytablet'></span>In-Play
                            </a>
                        }
                        {showSportsBookLink.show &&
                            <a onClick={() => { this.redirect('/sportbook') }} className={window.location.pathname === "/sportbook" ? "active sportbook-hl" : "sportbook-hl"}>
                                <span className='sports-icon sportbooktablet'></span>SportsBook
                            </a>
                        }
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/ipl') }} className={window.location.pathname === "/ipl" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> IPL 2025
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wplwinner') }} className={window.location.pathname === "/wplwinner" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> WPL 2025
                            </a>
                        } */}
                        {(!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && this.state.accessControl.sports) &&
                            <a onClick={() => { this.redirect('/game/500') }} className={window.location.pathname === "/game/500" ? "active awesomemobile" : "awesomemobile"}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.electInplay}</span>
                                <span className='sports-icon electiontablet'></span>{ElectionDisplayLabel}
                            </a>
                        }
                        {(!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && this.state.accessControl.sports) &&
                            <a onClick={() => { this.redirect('/game/400') }} className={window.location.pathname === "/game/400" ? "active awesomemobile" : "awesomemobile"}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.kbdInplay}</span>
                                <span className='sports-icon kabadditablet'></span>Kabaddi
                            </a>
                        }
                        {
                            this.state.accessControl.sports && !!winnereventdic && !!winnereventdic["eventDicByName"] && Object.keys(winnereventdic["eventDicByName"]).length > 0 && Object.keys(winnereventdic["eventDicByName"]).map((itm, i) => {
                                let itmm = winnereventdic["eventDicByName"][itm];
                                if (!itmm.show) {
                                    return false;
                                }
                                if (!itmm.showInMenu) {
                                    return false;
                                }
                                return (
                                    <a key={`2_${i}_${itm}`} onClick={() => { this.redirect(itmm["url"]) }} className={window.location.pathname === itmm["url"] ? "active awesomemobile" : "awesomemobile"}>
                                        <span className='sports-icon iplwinnertablet'></span> {itmm["displayName"]}
                                    </a>
                                )
                            })
                        }
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wbbl2025') }} className={window.location.pathname === "/wbbl2025" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> WBBL 2025
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wt20') }} className={window.location.pathname === "/wt20" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> WC Winner 2024
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/ivl') }} className={window.location.pathname === "/ivl" ? "active" : null}>
                                <span className='sports-icon iplwinnertablet'></span>IVL T10
                            </a>
                        } */}
                        {ShowSportsBattle && this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/sportsbattle') }} className={window.location.pathname === "/sportsbattle" || window.location.pathname.includes("/sportsbattleevent") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.cktInplay}</span>
                                <span className='sports-icon crickettablet'></span>Sports Battle
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/4') }} className={window.location.pathname === "/game/4" || window.location.pathname.includes("/event/4/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.cktInplay}</span>
                                <span className='sports-icon crickettablet'></span>Cricket
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/1') }} className={window.location.pathname === "/game/1" || window.location.pathname.includes("/event/1/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.socInplay}</span>
                                <span className='sports-icon soccertablet'></span>Soccer
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/2') }} className={window.location.pathname === "/game/2" || window.location.pathname.includes("/event/2/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.tenInplay}</span>
                                <span className='sports-icon tennistablet'></span> Tennis
                            </a>
                        }
                        {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && (!!accData && Object.keys(accData).length > 0) && this.state.accessControl.casino && <a onClick={() => { this.redirect('/clubgames') }} className={window.location.pathname === "/clubgames" ? "active awesomemobile" : "awesomemobile"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/indian-poker-icon.svg"} className="ball-images-tab new-scrollmenu" />Club Games</a>}
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/7') }} className={window.location.pathname === "/game/7" || window.location.pathname.includes("/event/7/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.horsInplay}</span>
                                <span className='sports-icon horsetablet'></span> Horse
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/4339') }} className={window.location.pathname === "/game/4339" || window.location.pathname.includes("/event/4339/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.houndInplay}</span>
                                <span className='sports-icon greyhoundtablet'></span> Greyhound
                            </a>
                        }
                        {/* {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/ipl') }} className={window.location.pathname === "/ipl" ? "active " : ""}>
                <span className='sports-icon iplwinnertablet'></span> IPL Winner 2023
              </a>
            } */}
                        {/* {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/pslwinner') }} className={window.location.pathname === "/pslwinner" ? "active " : ""}>
                <span className='sports-icon iplwinnertablet'></span> PSL Winner 2023
              </a>
            }
            {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/wplwinner') }} className={window.location.pathname === "/wplwinner" ? "active " : ""}>
                <span className='sports-icon iplwinnertablet'></span> WPL Winner 2023
              </a>
            } */}

                        {
                            this.state.accessControl.casino && Object.values(casinoList).map((itm, i) => {
                                return (itm.show &&
                                    <>
                                        <a key={`2_${itm.provider}_${i}`} onClick={() => { this.redirect(itm.url) }} className={window.location.pathname === itm.url ? "active " : ""}>
                                            {!!itm.iconImg ?
                                                <img className={itm.provider === "INOUT" ? "ball-images-tab1-inout-tablet" : (itm.iconontop ? "ball-images-tab1-aviator-tablet" : "ball-images-tab new-scrollmenu")} src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`} alt="" />
                                                :
                                                <span className={`sports-icon ${itm.iconClass}tablet`}></span>
                                            }
                                            {itm.displayName}
                                        </a>
                                    </>
                                );
                            })
                        }

                        {showEsportLink.show &&
                            <a onClick={() => { this.redirect('/esport') }} className={window.location.pathname === "/esport" ? "active sportbook-hl" : "sportbook-hl"}>
                                <span className='sports-icon sportbooktablet'></span>E-Sports
                            </a>
                        }
                        {(showBinary && this.state.accessControl.binary) &&
                            <a onClick={() => { this.redirect('/binary') }} className={window.location.pathname === "/binary" ? "active " : ""}>
                                <span className='sports-icon binarytablet'></span> Binary
                            </a>
                        }
                    </> :
                        <a onClick={() => { this.redirect('/games/3droulette') }} className={window.location.pathname === "/games/3droulette" ? "active" : null}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/roulette.svg"} className="ball-images-tab new-scrollmenu" />3D Roulette</a>
                    }
                </div>
                <div className="scrollmenu marposition" >
                    {!this.state.isMaintanance ? <>
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/inplay') }} className={window.location.pathname === "/inplay" ? "active" : null}>
                                <span className='sports-icon inplaymobile'></span> In-Play
                            </a>
                        }
                        {showSportsBookLink.show &&
                            <a onClick={() => { this.redirect('/sportbook') }} className={window.location.pathname === "/sportbook" ? "active sportbook-hl" : "sportbook-hl"}>
                                <span className='sports-icon sportbookmobile'></span>SportsBook
                            </a>
                        }
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/ipl') }} className={window.location.pathname === "/ipl" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> IPL 2025
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wplwinner') }} className={window.location.pathname === "/wplwinner" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnertablet'></span> WPL 2025
                            </a>
                        } */}
                        {(!!winnereventdic && !!winnereventdic.election && winnereventdic.election.show === true && this.state.accessControl.sports) &&
                            <a onClick={() => { this.redirect('/game/500') }} className={window.location.pathname === "/game/500" ? "active awesomemobile" : "awesomemobile"}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.electInplay}</span>
                                <span className='sports-icon electionmobile'></span>{ElectionDisplayLabel}
                            </a>
                        }
                        {(!!winnereventdic && !!winnereventdic.kabaddi && winnereventdic.kabaddi.show === true && this.state.accessControl.sports) &&
                            <a onClick={() => { this.redirect('/game/400') }} className={window.location.pathname === "/game/400" ? "active awesomemobile" : "awesomemobile"}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.kbdInplay}</span>
                                <span className='sports-icon kabaddimobile'></span>Kabaddi
                            </a>
                        }
                        {
                            this.state.accessControl.sports && !!winnereventdic && !!winnereventdic["eventDicByName"] && Object.keys(winnereventdic["eventDicByName"]).length > 0 && Object.keys(winnereventdic["eventDicByName"]).map((itm, i) => {
                                let itmm = winnereventdic["eventDicByName"][itm];
                                if (!itmm.show) {
                                    return false;
                                }
                                if (!itmm.showInMenu) {
                                    return false;
                                }
                                return (
                                    <a key={`3_${i}_${itm}`} onClick={() => { this.redirect(itmm["url"]) }} className={window.location.pathname === itmm["url"] ? "active awesomemobile" : "awesomemobile"}>
                                        <span className='sports-icon iplwinnermobile'></span>{itmm["displayName"]}
                                    </a>
                                )
                            })
                        }
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wbbl2025') }} className={window.location.pathname === "/wbbl2025" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnermobile'></span>WBBL 2025
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/wt20') }} className={window.location.pathname === "/wt20" ? "active awesomemobile" : "awesomemobile"}>
                                <span className='sports-icon iplwinnermobile'></span>WC Winner 2024
                            </a>
                        } */}
                        {/* {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/ivl') }} className={window.location.pathname === "/ivl" ? "active" : null}>
                                <span className='sports-icon iplwinnermobile'></span>IVL T10
                            </a>
                        } */}
                        {ShowSportsBattle && this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/sportsbattle') }} className={window.location.pathname === "/sportsbattle" || window.location.pathname.includes("/sportsbattleevent") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.cktInplay}</span>
                                <span className='sports-icon cricketmobile'></span>Sports Battle
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/4') }} className={window.location.pathname === "/game/4" || window.location.pathname.includes("/event/4/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.cktInplay}</span>
                                <span className='sports-icon cricketmobile'></span>Cricket
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/1') }} className={window.location.pathname === "/game/1" || window.location.pathname.includes("/event/1/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.socInplay}</span>
                                <span className='sports-icon soccermobile'></span>Soccer
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/2') }} className={window.location.pathname === "/game/2" || window.location.pathname.includes("/event/2/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.tenInplay}</span>
                                <span className='sports-icon tennismobile'></span> Tennis
                            </a>
                        }
                        {((showClubGames.onlyInOfficeChnl ? this.state.isOfficeChannel : false) || showClubGames.show) && (!!accData && Object.keys(accData).length > 0) && this.state.accessControl.casino && <a onClick={() => { this.redirect('/clubgames') }} className={window.location.pathname === "/clubgames" ? "active awesomemobile" : "awesomemobile"}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/indian-poker-icon.svg"} className="ball-images-tab new-scrollmenu" />Club Games</a>}
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/7') }} className={window.location.pathname === "/game/7" || window.location.pathname.includes("/event/7/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.horsInplay}</span>
                                <span className='sports-icon horsemobile'></span>Horse
                            </a>
                        }
                        {this.state.accessControl.sports &&
                            <a onClick={() => { this.redirect('/game/4339') }} className={window.location.pathname === "/game/4339" || window.location.pathname.includes("/event/4339/") ? "active" : null}>
                                <span id="tagLive" className="tag-livemobile"><strong></strong>{this.state.houndInplay}</span>
                                <span className='sports-icon greyhoundmobile'></span>Greyhound
                            </a>
                        }
                        {/* {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/ipl') }} className={window.location.pathname === "/ipl" ? "active " : ""}>
                <span className='sports-icon iplwinnermobile'></span>IPL Winner 2023
              </a>
            } */}
                        {/* {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/pslwinner') }} className={window.location.pathname === "/pslwinner" ? "active " : ""}>
                <span className='sports-icon iplwinnermobile'></span>PSL Winner 2023
              </a>
            }
            {this.state.accessControl.sports &&
              <a onClick={() => { this.redirect('/wplwinner') }} className={window.location.pathname === "/wplwinner" ? "active " : ""}>
                <span className='sports-icon iplwinnermobile'></span>WPL Winner 2023
              </a>
            } */}

                        {
                            this.state.accessControl.casino && Object.values(casinoList).map((itm, i) => {
                                return (itm.show &&
                                    <>

                                        <a key={`3_${itm.provider}_${i}`} onClick={() => { this.redirect(itm.url) }} className={window.location.pathname === itm.url ? "active " : ""}>
                                            {!!itm.iconImg ?
                                                <img className={itm.iconontop ? "ball-images-tab1-aviator-mobile" : "ball-images-tab new-scrollmenu inout-images-tab"} src={`${BASE_IMAGE_PATH}/casino/banner/images/${itm.iconImg}`} alt="" />
                                                :
                                                <span className={`sports-icon ${itm.iconClass}mobile`}></span>
                                            }
                                            {itm.displayName}
                                        </a>
                                    </>
                                );
                            })
                        }

                        {showEsportLink.show &&
                            <a onClick={() => { this.redirect('/esport') }} className={window.location.pathname === "/esport" ? "active sportbook-hl" : "sportbook-hl"}>
                                <span className='sports-icon sportbookmobile'></span>E-Sports
                            </a>
                        }
                        {(showBinary && this.state.accessControl.binary) &&
                            <a onClick={() => { this.redirect('/binary') }} className={window.location.pathname === "/binary" ? "active " : ""}>
                                <span className='sports-icon binarymobile'></span>Binary
                            </a>
                        }
                    </> :
                        <a onClick={() => { this.redirect('/games/3droulette') }} className={window.location.pathname === "/games/3droulette" ? "active" : null}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/roulette.svg"} className="ball-images-tab new-scrollmenu" />3D Roulette</a>
                    }
                </div>
            </>
        );
    }
}
